// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:58:03.245Z
// Property: Wind River Lodge Apartments & Townhomes (ID: 6767906449167625)
// Collections: 28 amenities, 5 floorplans (live), 48 photos, 76 POIs, 4 reviews, 6 office hours, 1 special offers (live), 18 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167625",
  "property_external_id": "1124408",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/wind-river-lodge-apartments-townhomes-lenexa-ks/955dhs5/",
  "property_google_business_url": "https://www.google.com/maps/place/Wind+River+Lodge+Apartments+%26+Townhomes/@38.9606078,-94.7715303,1779m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c094625b5ca76b:0x329fe0b462ca3db4!8m2!3d38.9606078!4d-94.7715303!16s%2Fg%2F1tx15wth?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124408 p1099359",
  "property_status": null,
  "property_slug": "wind-river-lodge-apartments-&-townhomes",
  "property_name": "Wind River Lodge Apartments & Townhomes",
  "property_website_url": "https://www.windriverlodgeapts.com/",
  "property_domain": "https://www.windriverlodgeapts.com/",
  "property_address": "9250 Lichtenauer Dr",
  "property_full_address": "9250 Lichtenauer Dr, Lenexa, KS 66219",
  "property_address_1": "9250 Lichtenauer Dr",
  "property_address_2": null,
  "property_address_city": "Lenexa",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66219",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Chesapeake Estates",
  "property_address_latitude": "38.9606129",
  "property_address_longitude": "-94.7715047",
  "property_email": "rentcafe.wr@pricekc.com",
  "property_phone": "(913) 372-3229",
  "property_call_tracking_phone": "913-372-3229",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Contemporary comfort in Chesapeake Estates.</strong> Wind River Lodge pairs relaxed Lenexa living with spacious apartment and townhome-style layouts, everyday in-home conveniences, and standout community spaces—browse <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to picture your next address.</p>",
  "property_long_description": "<p><strong>Contemporary comfort in Chesapeake Estates.</strong> At Wind River Lodge Apartments &amp; Townhomes, you get a relaxed Lenexa setting with the space and flexibility of one- and two-bedroom apartments plus townhome-style layouts. Step outside to two swimming pools, including an Olympic-size pool, then keep the day moving with a sauna, state-of-the-art fitness center, tennis court, sand volleyball, sundeck, grills, and inviting clubhouse spaces. Inside, enjoy practical everyday details like high-speed internet readiness with Google Fiber, washer/dryer connections, private patios or balconies, and select finishes such as vaulted ceilings, fireplaces, breakfast bars, espresso cabinets, and stainless steel appliances. Explore more on the <a href=\"/amenities\">amenities page</a>.</p><p>From your spot near 95th Street, I-435, I-35, and K-10, Lenexa City Center, Lenexa Public Market, Oak Park Mall, Sar-Ko-Par Trails Park, Shawnee Mission Park, and major Johnson County destinations are all within easy reach. See the latest <a href=\"/floor-plans\">floor plans</a>, browse the <a href=\"/gallery\">photo gallery</a>, and picture your next address at Wind River Lodge.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-074d-72cc-9901-4d2a8c289a32.webp",
  "property_featured_image_media": {
    "alt_text": "Modern lounge area with seating, kitchen, and large windows overlooking trees and buildings.",
    "public_id": "01a0b67a-074d-72cc-9901-4d2a8c289a32",
    "storage_key": "property/6767906449167625/01a0b67a-074d-72cc-9901-4d2a8c289a32.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "568",
  "property_year_built": "1986",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.35915492957746",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://windriverlodgeapts.securecafeapplicant.com/onlineleasing/content3/access/wind-river-lodge/floorplans",
  "property_resident_portal_url": "https://windriverlodgeapts.securecafe.com/residentservices/wind-river-lodge/userlogin.aspx",
  "property_apply_now_url": "https://windriverlodgeapts.securecafeapplicant.com/onlineleasing/content3/access/wind-river-lodge/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc98f-a52a-75f8-a139-9024322d6bef.webp",
  "property_primary_logo_media": {
    "alt_text": "Wind River Lodge Apartments & Townhomes logo",
    "public_id": "019fc98f-a52a-75f8-a139-9024322d6bef",
    "storage_key": "property/6767906449167625/019fc98f-a52a-75f8-a139-9024322d6bef.webp",
    "width": 1053,
    "height": 150
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a1-eb9c-75ec-a5c3-7c50aa5095ca.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019ff6a1-eb9c-75ec-a5c3-7c50aa5095ca",
    "storage_key": "property/6767906449167625/019ff6a1-eb9c-75ec-a5c3-7c50aa5095ca.webp",
    "width": 1053,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc98f-a52a-75f8-a139-9024322d6bef.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Wind River Lodge Apartments & Townhomes logo",
    "public_id": "019fc98f-a52a-75f8-a139-9024322d6bef",
    "storage_key": "property/6767906449167625/019fc98f-a52a-75f8-a139-9024322d6bef.webp",
    "width": 1053,
    "height": 150
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#003865",
  "property_secondary_color": "#8A391B",
  "property_font_color": null,
  "property_color_4": "#007DBA",
  "property_color_3": "#F0B323",
  "property_color_5": "#00C49A",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "610 - 1185",
  "property_sqft_min": "610",
  "property_sqft_max": "1185",
  "property_price_range": "1161 - 4741",
  "property_price_min": "1161",
  "property_price_max": "4741",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/WindriverLodgeApts",
  "property_instagram_url": "https://www.instagram.com/windriverlodgeapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJa6dcW2KUwIcRtD3KYrTgnzI",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Wind River Lodge Apartments & Townhomes",
  "property_home_romance_title": "Embrace the Comfort of Your New Apartment Oasis",
  "property_home_amenities_blurb": "<p><strong>Amenities with room to reset, recharge, and get moving.</strong> At Wind River Lodge Apartments &amp; Townhomes, swim laps in the Olympic-size pool, unwind in the sauna, train in the fitness center, or play on the tennis and sand volleyball courts. Everyday perks like sundeck seating, grilling areas, clubhouse spaces, covered parking options, Google Fiber readiness, washer/dryer connections, and private patios or balconies bring extra ease to life in Lenexa.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to make your move.</strong> Choose from one-bedroom apartments, spacious two-bedroom homes, and a townhome-style layout with added separation. Private patios or balconies, walk-in closets, washer/dryer connections, and Google Fiber readiness bring everyday ease, while select homes add vaulted ceilings, fireplaces, breakfast bars, upgraded fixtures, or stainless steel appliances.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the Wind River Lodge look.</strong> Flip through bright living rooms, fireplace details, open kitchens with breakfast bars, and updated finishes, then step outside to blue pool water, sunny deck seating, sport courts, grilling areas, and lodge-style clubhouse spaces. The gallery also highlights patios, balconies, and select vaulted-ceiling views—just enough to picture the textures, layouts, and relaxed Lenexa setting before seeing it all in person.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Connected Lenexa, with green space close by.</strong> At Wind River Lodge Apartments &amp; Townhomes, Chesapeake Estates puts highways, the 95th Street corridor, and Lenexa City Center within easy reach. Grab coffee, browse local dining, catch community events, or sample rotating flavors at Lenexa Public Market—then unwind at City Center Park or Sar-Ko-Par Trails Park with pond paths, disc golf, courts, and gardens nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews say it best.</strong> Wind River Lodge earns praise for affordable rent, helpful leasing support, and a setting that feels like home. Reviews often mention well-kept grounds, friendly service, quick maintenance, resident appreciation events, and everyday perks like the pool. See why life in Chesapeake Estates stands out—then read the full reviews for more resident perspectives.</p>",
  "property_neighborhood_blurb": "<p><strong>Lenexa convenience with room to roam.</strong> From Wind River Lodge Apartments &amp; Townhomes in Chesapeake Estates, your everyday map opens in every direction: quick highway connections for cross-metro errands, the 95th Street corridor for shopping and dining, and Lenexa City Center for coffee, local bites, library stops, public events, and the Lenexa Public Market’s rotating flavors. When you want fresh air, City Center Park adds a pond-side loop trail close by, while Sar-Ko-Par Trails Park brings disc golf, courts, gardens, and Rose’s Pond into the weekend mix. Explore the map below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this Lenexa location fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces that keep pace with your day.</strong> At Wind River Lodge Apartments &amp; Townhomes in Lenexa, you can move from laps in the Olympic-size pool to a sauna session, a workout in the fitness center, or a match on the tennis and sand volleyball courts without leaving the community. Sundeck seating, grilling areas, clubhouse spaces, covered parking options, online resident services, and 24-hour emergency maintenance add everyday ease where it counts.</p><p>Inside, your home supports the details of daily living with high-speed internet readiness including Google Fiber, washer/dryer connections, air conditioning, and private patio or balcony space. Select layouts add even more character with vaulted ceilings, fireplaces, breakfast bars, upgraded fixtures, espresso cabinets, or stainless steel appliances. Browse the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to call Wind River Lodge home?</strong><br>Choose from one- and two-bedroom apartments and townhome-style layouts in a relaxed Lenexa setting, with everyday comforts like washer/dryer connections, private patios or balconies, and high-speed internet readiness. Start your online application today and take the next step toward your new address.</p>",
  "property_contactus_blurb": "<p><strong>Have a question? We’re here to help.</strong> Contact the Wind River Lodge leasing team for details about our apartments and townhome-style layouts, current availability, or directions to our relaxed Lenexa setting near major roadways. Reach out today and take the next step toward your new address.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Wind River Lodge?</strong> Start here for quick answers about the community, leasing, floor plans, amenities, and everyday living in our Lenexa apartments and townhome-style layouts. If you need more details, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the floor plan that feels like yours.</strong> At Wind River Lodge Apartments &amp; Townhomes, you can compare comfortable one-bedroom layouts, roomy two-bedroom apartments, and a townhome-style option with added separation for the way you use your space. As you browse availability, look for everyday details that make each home feel more complete—private patio or balcony space, walk-in closets, washer/dryer connections, high-speed internet readiness with Google Fiber, and select homes with vaulted ceilings, fireplaces, breakfast bars, upgraded fixtures, or stainless steel appliances.</p><p>Use the floor plan cards to weigh layout, pricing, and move-in timing at a glance, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorites in person in Lenexa.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces that make Wind River Lodge feel complete.</strong> Browse photos that move from bright living rooms and fireplace details to open kitchens with breakfast bars, updated finishes, and room to settle into your routine.</p><p>Outside, the gallery captures the community’s relaxed Lenexa setting: blue pool water beside sunny deck seating, courts ready for a match, grilling spots, and clubhouse spaces that give the property its lodge-like rhythm. Take a closer look at patios and balconies, vaulted-ceiling views in select homes, and the everyday details that help each layout stand out. When a photo catches your eye, explore the <a href=\"/floor-plans\">available floor plans</a>, compare the <a href=\"/amenities\">featured amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Wind River Lodge on the map.</strong><br>See available apartments and townhome-style layouts in a relaxed Lenexa setting near 95th Street, I-435, I-35, and K-10. Use the interactive map to picture daily convenience, nearby destinations, and your next address in Chesapeake Estates.</p>",
  "property_pets_blurb": "<p><strong>Bring the whole pet routine home.</strong> At Wind River Lodge Apartments &amp; Townhomes, cats, dogs, and rabbits are welcome, so your space can work for the companions who share your day. Step out for fresh air on your private patio or balcony, keep supplies organized with practical in-home storage, and use the community’s <a href=\"/amenities\">Pet Royalty Program</a> to add a little extra ease to pet life.</p><p>When your dog needs a bigger adventure, Lenexa puts you close to Shawnee Mission Park’s 44-acre off-leash area with trails, lake access, and a dog beach. Back at home, on-site maintenance, laundry facilities, and online resident services help keep daily pet care simple. Review the policy details below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how pet-friendly living fits here.</p>",
  "property_referafriend_blurb": "<p><strong>Share the comfort of Wind River Lodge.</strong><br>Love the relaxed Lenexa setting, spacious apartment and townhome-style layouts, and everyday perks like two swimming pools, fitness space, Google Fiber readiness, and private patios or balconies? Invite a friend to picture their next address here, too.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Wind River Lodge.</strong> Log in to pay rent, submit maintenance requests, and manage your account with ease—so you can get back to enjoying contemporary comfort in Chesapeake Estates, from flexible apartment and townhome-style layouts to relaxed community spaces.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents appreciate most.</strong> As you browse reviews for Wind River Lodge Apartments &amp; Townhomes, you’ll see recurring praise for affordable rent, helpful leasing support, and a setting that “really feels like a home rather than just an apartment!”</p><p>Residents highlight well-kept grounds, good neighbors, move-in help from the front office, and maintenance that is often handled quickly. You’ll also find comments about resident appreciation events, a nice area, and a pool that adds to the everyday experience. Read through the reviews below to get a real resident perspective on life at Wind River Lodge in Chesapeake Estates.</p>",
  "property_created_at": "1785793006872",
  "property_scheduletour_blurb": "<p><strong>See Wind River Lodge in person.</strong> Tour the one- and two-bedroom apartments and townhome-style layouts, then picture the everyday ease of private outdoor space, Google Fiber readiness, and inviting community spots made for relaxing between errands, workouts, and Lenexa days. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out.</strong><br>Your inquiry has been received, and the Wind River Lodge leasing team will follow up soon. In the meantime, picture relaxed Lenexa living with spacious apartment and townhome-style layouts, contemporary comforts, and inviting community spaces designed to make everyday life feel easy.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Wind River Lodge Apartments & Townhomes",
  "property_seo_title_home": "Wind River Lodge Apartments & Townhomes |  Apartments in Lenexa, KS",
  "property_seo_description_home": "Experience modern living at Wind River Lodge in Lenexa, KS. Enjoy spacious floor plans, top-notch amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Lenexa, KS Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Wind River Lodge Apartments & Townhomes in Lenexa, KS. From cozy one-bedrooms to spacious two-bedrooms, your perfect floor plan awaits!",
  "property_seo_title_amenities": "Amenities | Lenexa, KS Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Wind River Lodge in Lenexa! Enjoy top-tier amenities, spacious floor plans, and a vibrant community. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Lenexa, KS",
  "property_seo_description_gallery": "Discover Wind River Lodge Apartments in Lenexa, KS! Enjoy spacious homes, great amenities, and a vibrant community for your new lifestyle!",
  "property_seo_title_virtualtours": "Virtual Tours | Wind River Lodge Apartments & Townhomes Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Wind River Lodge Apartments in Lenexa, KS. Dive into our virtual tour and envision your perfect one or two-bedroom home today!",
  "property_seo_title_interactivemap": "Interactive Map | Wind River Lodge Apartments & Townhomes Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Wind River Lodge Apartments in Lenexa, KS! Use our interactive map to explore spacious floor plans and resort-style amenities today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Lenexa, KS",
  "property_seo_description_neighborhood": "Uncover the charm of Lenexa, KS at Wind River Lodge Apartments & Townhomes. Dive into local favorites and vibrant community hotspots just steps away!",
  "property_seo_title_contact": "Contact Us | Wind River Lodge Apartments & Townhomes",
  "property_seo_description_contact": "Reach out to Wind River Lodge Apartments & Townhomes in Lenexa, KS! Our friendly leasing team is ready to assist with your one or two-bedroom inquiries.",
  "property_seo_title_faqs": "FAQs | Apartments in Lenexa, KS",
  "property_seo_description_faqs": "Find answers to your queries about Wind River Lodge Apartments in Lenexa, KS. From amenities to leasing info, our FAQs have you covered!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Lenexa, KS",
  "property_seo_description_reviews": "Discover the Wind River Lodge lifestyle in Lenexa, KS! Enjoy luxury amenities and a warm atmosphere. Experience why residents love living here!",
  "property_seo_title_applynow": "Apply Now | Apartments in Lenexa, KS",
  "property_seo_description_applynow": "Find your oasis at Wind River Lodge Apartments in Lenexa, KS! Enjoy top-notch amenities, versatile floor plans, and a vibrant community. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Wind River Lodge Apartments & Townhomes",
  "property_seo_description_residentaccess": "Access the Wind River Lodge portal for easy rent payments, maintenance requests, and community updates in Lenexa, KS!",
  "property_seo_title_referafriend": "Refer A Friend | Wind River Lodge Apartments & Townhomes",
  "property_seo_description_referafriend": "Refer a friend to Wind River Lodge Apartments in Lenexa, KS! Share the joy of community living where great friends create lasting memories together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Wind River Lodge Apartments & Townhomes",
  "property_seo_description_scheduletour": "Experience the charm of Wind River Lodge in Lenexa, KS. Schedule a tour today and envision your new home amidst scenic views and unbeatable amenities!",
  "property_seo_title_privacy": "Privacy Policy | Wind River Lodge Apartments & Townhomes",
  "property_seo_description_privacy": "Safeguard your peace of mind at Wind River Lodge Apartments & Townhomes. Dive into our privacy policy to see how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Wind River Lodge Apartments & Townhomes",
  "property_seo_description_accessibility": "At Wind River Lodge in Lenexa, KS, we ensure digital inclusion for all. Experience accessibility designed to enhance your apartment living. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Wind River Lodge Apartments & Townhomes",
  "property_seo_description_sitemap": "Navigate our Wind River Lodge Apartments & Townhomes sitemap to easily find your future home in Lenexa, KS. Your next adventure awaits just a click away!",
  "property_seo_title_thankyou": "Thank You | Wind River Lodge Apartments & Townhomes",
  "property_seo_description_thankyou": "Thanks for contacting Wind River Lodge in Lenexa! Our team will be in touch soon to help you with comfortable living in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Lenexa, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793628993535",
  "amenities": [
    {
      "id": "ec_5d2bdf41b3214ba57e1d58ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87847217",
      "title": "Two Swimming Pools, Including an Olympic Size Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-353b-72f5-b33c-c9e5ae61ad0a.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "01a0b67a-353b-72f5-b33c-c9e5ae61ad0a",
        "storage_key": "property/6767906449167625/01a0b67a-353b-72f5-b33c-c9e5ae61ad0a.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Two Swimming Pools, Including one Olympic Size Pool at Wind River Lodge, Lenexa,Two Swimming Pools, Including one Olympic Size Pool at Wind River Lodge, Lenexa, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fbdb4562ac8f160ab39bfe0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87926061",
      "title": "Carports Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-1f44-718e-be41-12f3269ec1fa.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking spaces with cars parked in them.",
        "public_id": "01a0b67a-1f44-718e-be41-12f3269ec1fa",
        "storage_key": "property/6767906449167625/01a0b67a-1f44-718e-be41-12f3269ec1fa.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Covered resident parking carports at Wind River Lodge Apartments with reserved parking spaces and apartment homes visible in the background.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_782dbd69ffbf52e982954161",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87847216",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-3511-774d-b9f9-77f9203d9d94.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with stacked washers and dryers, and additional front-loading washers.",
        "public_id": "01a0b67a-3511-774d-b9f9-77f9203d9d94",
        "storage_key": "property/6767906449167625/01a0b67a-3511-774d-b9f9-77f9203d9d94.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Shared laundry facility at Wind River Lodge Apartments featuring multiple washers, dryers, and clean modern finishes.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bdcbd0019794f1583635984",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87847222",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de949c75baa1226462c652bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87847219",
      "title": "Non-Smoking Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a15c10f6ec58462e95ce3798",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87847221",
      "title": "State-Of-The-Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-1f53-779b-9b11-94ef28e14633.webp",
      "amenity_image_media": {
        "alt_text": "Well-equipped gym with free weights, weight machines, treadmills, and stationary bikes.",
        "public_id": "01a0b67a-1f53-779b-9b11-94ef28e14633",
        "storage_key": "property/6767906449167625/01a0b67a-1f53-779b-9b11-94ef28e14633.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "State-Of-The-Art Fitness Center at Wind River Lodge, Kansas, 66219",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6217700c0ca08dbc2a11d6c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87847220",
      "title": "Sand Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-1fd3-726d-95ab-6a97a9caa868.webp",
      "amenity_image_media": {
        "alt_text": "Volleyball court and swimming pool area with lounge chairs.",
        "public_id": "01a0b67a-1fd3-726d-95ab-6a97a9caa868",
        "storage_key": "property/6767906449167625/01a0b67a-1fd3-726d-95ab-6a97a9caa868.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "Sand volleyball court adjacent to the swimming pool and clubhouse amenities at Wind River Lodge Apartments in Lenexa, Kansas.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eae793fea7e7eb8af23e5a12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87926060",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50fe19cce72059e82b94e781",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87926063",
      "title": "Easy Highway Access to I-435, I-35 and K-10",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-2a2f-71bf-9f0e-6eb768fad94e.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of a sprawling apartment complex with multiple buildings, surrounding greenery, and a nearby highway.",
        "public_id": "01a0b67a-2a2f-71bf-9f0e-6eb768fad94e",
        "storage_key": "property/6767906449167625/01a0b67a-2a2f-71bf-9f0e-6eb768fad94e.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "Bird's-eye view of Wind River Lodge Apartments showcasing residential buildings, community amenities, nearby ponds, and surrounding Lenexa neighborhoods.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff95608ef9003a807aa972d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "121152265",
      "title": "Pet Royalty Program",
      "amount": "false",
      "description": "At Price Brothers, we love our pets just as much as we love serving our customers.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74166dc155df348c8215eaa4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "121152268",
      "title": "Online Resident Services",
      "amount": "false",
      "description": "Service Requests, Online Payments, and More",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6f3a54e3068fcb9769034cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "122755417",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_007ee37e96bcf125c626fe89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "121165186",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc991-87e4-71fc-84cd-15fb53417292.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white appliances, wood cabinets, and granite countertops.",
        "public_id": "019fc991-87e4-71fc-84cd-15fb53417292",
        "storage_key": "property/6767906449167625/019fc991-87e4-71fc-84cd-15fb53417292.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A kitchen with a white refrigerator and wooden cabinets.,Apartment kitchen with wood cabinetry, black appliances, updated countertops, and adjacent dining area.,Bright kitchen featuring white cabinetry, modern appliances, generous countertop space, and a large window overlooking the community.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6b7a5fc4f152f08aa908bcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "121165185",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e876df09e32aeaf45760dc4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "121165183",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5716c3e97f1d458eeb827d2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "121165184",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f83a8dc2d9bb9c5bfb236b0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87847226",
      "title": "Ceiling Fan(s)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc98f-a721-776e-b50c-6d22f92fd56a.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a bed, nightstand, closet, and chair.",
        "public_id": "019fc98f-a721-776e-b50c-6d22f92fd56a",
        "storage_key": "property/6767906449167625/019fc98f-a721-776e-b50c-6d22f92fd56a.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A bedroom with a bed, a ceiling fan, and a wardrobe.,Open-concept living room featuring modern furnishings, wood-style flooring, and direct access to the kitchen and dining areas.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c16950966439680dd377ab23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87847227",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2059607a3ebe49260ee2e1dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87847228",
      "title": "Washer/Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-33d6-76e8-b43d-df8ee58ed1a6.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen and laundry room with washing machines.",
        "public_id": "01a0b67a-33d6-76e8-b43d-df8ee58ed1a6",
        "storage_key": "property/6767906449167625/01a0b67a-33d6-76e8-b43d-df8ee58ed1a6.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Laundry area located adjacent to the kitchen in a Wind River Lodge apartment home.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3ee2a1525c06bf650c633aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87847225",
      "title": "High Speed Internet Ready, including Google Fiber",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0266124e06d35e8338127e11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87926040",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-4cc2-730c-9578-006bd9e3207f.webp",
      "amenity_image_media": {
        "alt_text": "Covered patio with a table and chairs overlooking a grassy area and apartment buildings.",
        "public_id": "01a0b67a-4cc2-730c-9578-006bd9e3207f",
        "storage_key": "property/6767906449167625/01a0b67a-4cc2-730c-9578-006bd9e3207f.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Private covered patio at Wind River Lodge Apartments featuring outdoor seating, landscaped grounds, mature trees, and views of the community.,Private covered patio with outdoor seating and direct access to a Wind River Lodge apartment home.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_461f116336b33a59bf6df72c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87926045",
      "title": "Breakfast Bar*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-4c7d-77ed-923c-82422cabb837.webp",
      "amenity_image_media": {
        "alt_text": "Dining area and living room in apartment with light-colored walls, wood floors, and modern furniture.",
        "public_id": "01a0b67a-4c7d-77ed-923c-82422cabb837",
        "storage_key": "property/6767906449167625/01a0b67a-4c7d-77ed-923c-82422cabb837.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Dining space connected to the kitchen and living area with breakfast bar seating and contemporary staging.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b69230ddd645873535cbaf5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "122007004",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc991-87e4-71fc-84cd-15fb53417292.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white appliances, wood cabinets, and granite countertops.",
        "public_id": "019fc991-87e4-71fc-84cd-15fb53417292",
        "storage_key": "property/6767906449167625/019fc991-87e4-71fc-84cd-15fb53417292.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A kitchen with a white refrigerator and wooden cabinets.,Apartment kitchen with wood cabinetry, black appliances, updated countertops, and adjacent dining area.,Updated kitchen with stainless steel appliances, white cabinetry, and an open floor plan connecting to the living area.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a477e7b36e46d6273f5cf34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "87926049",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be941970e710a725e9deb3c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "122007005",
      "title": "Upgraded Fixtures*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb9ff2fd44addced8b4a1d87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "122007007",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-3cd8-763a-a2b7-fb243ebc4916.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with stainless steel appliances and granite countertops.",
        "public_id": "01a0b67a-3cd8-763a-a2b7-fb243ebc4916",
        "storage_key": "property/6767906449167625/01a0b67a-3cd8-763a-a2b7-fb243ebc4916.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Bright kitchen featuring white cabinetry, modern appliances, generous countertop space, and a large window overlooking the community.,Updated kitchen with stainless steel appliances, white cabinetry, and an open floor plan connecting to the living area.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7084621987b6b4fc762ebcaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "122007009",
      "title": "Espresso Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39a31642d451c080eb307412",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "yardi",
      "external_id": "122020604",
      "title": "Black Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-54db-757b-bde0-88e9db4209c1.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with black appliances, wood cabinets, and granite countertops.",
        "public_id": "01a0b67a-54db-757b-bde0-88e9db4209c1",
        "storage_key": "property/6767906449167625/01a0b67a-54db-757b-bde0-88e9db4209c1.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Apartment kitchen with wood cabinetry, black appliances, updated countertops, and adjacent dining area.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_5841aacf2815a38a5125f675",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-074d-72cc-9901-4d2a8c289a32.webp",
      "image_media": {
        "alt_text": "Modern lounge area with seating, kitchen, and large windows overlooking trees and buildings.",
        "public_id": "01a0b67a-074d-72cc-9901-4d2a8c289a32",
        "storage_key": "property/6767906449167625/01a0b67a-074d-72cc-9901-4d2a8c289a32.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a modern kitchen, and plenty of natural light. Perfect for socializing or quiet reflection.",
      "link": "false",
      "alt_text": "Modern lounge area with seating, kitchen, and large windows overlooking trees and buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/9250 lichtenauer dr-2.jpg"
    },
    {
      "id": "ec_55caab5c7474d83219957c03",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-9867-72e5-bbe1-a7ebf8c7119e.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio equipment, free weights, and weight machines.",
        "public_id": "01a0b67a-9867-72e5-bbe1-a7ebf8c7119e",
        "storage_key": "property/6767906449167625/01a0b67a-9867-72e5-bbe1-a7ebf8c7119e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring state-of-the-art cardio machines, free weights, and strength training equipment.",
      "link": "false",
      "alt_text": "Fitness center with cardio equipment, free weights, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/9250 lichtenauer dr-5.jpg"
    },
    {
      "id": "ec_1c07ca8f7567ab0945cab257",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-73d9-748f-819d-6463dfac22af.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with white sofa, dining table, and breakfast bar.",
        "public_id": "01a0b67a-73d9-748f-819d-6463dfac22af",
        "storage_key": "property/6767906449167625/01a0b67a-73d9-748f-819d-6463dfac22af.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area flowing into a modern kitchen, perfect for entertaining and everyday living. Features include a breakfast bar and ample natural light.",
      "link": "false",
      "alt_text": "Modern living room and kitchen area with white sofa, dining table, and breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-DSC05285_ ver scan_final.jpg"
    },
    {
      "id": "ec_beb135a4d8474a8cbe19f2e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-73d0-73d2-9bf2-fab18b544558.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a bed, ceiling fan, closet, and decorative art.",
        "public_id": "01a0b67a-73d0-73d2-9bf2-fab18b544558",
        "storage_key": "property/6767906449167625/01a0b67a-73d0-73d2-9bf2-fab18b544558.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A beautifully staged bedroom featuring a comfortable bed, modern ceiling fan, and ample closet space, creating a serene and inviting atmosphere.",
      "link": "false",
      "alt_text": "Stylish bedroom with a bed, ceiling fan, closet, and decorative art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-DSC05340_final.jpg"
    },
    {
      "id": "ec_d9b5d448504d2fe3d71a671e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-7425-72a4-9675-583fd20122d9.webp",
      "image_media": {
        "alt_text": "Kitchen with black refrigerator, wood cabinets, and granite countertops.",
        "public_id": "01a0b67a-7425-72a4-9675-583fd20122d9",
        "storage_key": "property/6767906449167625/01a0b67a-7425-72a4-9675-583fd20122d9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring ample cabinet space, granite countertops, and a full-size refrigerator. Perfect for all your cooking needs.",
      "link": "false",
      "alt_text": "Kitchen with black refrigerator, wood cabinets, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/1-9250 Lichtenauer Dr-1.jpg"
    },
    {
      "id": "ec_1462ec8848d6bf9dfe47c884",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-73ca-76de-9322-d9abca7014bf.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white refrigerator, and granite countertops.",
        "public_id": "01a0b67a-73ca-76de-9322-d9abca7014bf",
        "storage_key": "property/6767906449167625/01a0b67a-73ca-76de-9322-d9abca7014bf.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen space featuring ample wooden cabinetry, a white refrigerator, and dark granite countertops. This apartment kitchen is equipped for your culinary needs.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, white refrigerator, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3-9250 Lichtenauer Dr-3.jpg"
    },
    {
      "id": "ec_d85a749cc24b01cd5df7ebbd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-80e3-7377-8a19-ab584bd03eda.webp",
      "image_media": {
        "alt_text": "View of a bedroom with a king-size bed, ceiling fan, and mounted TV.",
        "public_id": "01a0b67a-80e3-7377-8a19-ab584bd03eda",
        "storage_key": "property/6767906449167625/01a0b67a-80e3-7377-8a19-ab584bd03eda.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, modern ceiling fan, and a wall-mounted TV for your entertainment.",
      "link": "false",
      "alt_text": "View of a bedroom with a king-size bed, ceiling fan, and mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-DSC05325_final.jpg"
    },
    {
      "id": "ec_e44d525f6f1855321f736652",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-8183-7637-982f-125598e2c65d.webp",
      "image_media": {
        "alt_text": "Open-concept living and dining area with a kitchen island and bar stools.",
        "public_id": "01a0b67a-8183-7637-982f-125598e2c65d",
        "storage_key": "property/6767906449167625/01a0b67a-8183-7637-982f-125598e2c65d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this spacious open-concept apartment, featuring a modern kitchen island with bar stools, perfect for casual dining and entertaining.",
      "link": "false",
      "alt_text": "Open-concept living and dining area with a kitchen island and bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-DSC05285_final.jpg"
    },
    {
      "id": "ec_28788c278ad771661a1dc1ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-9b07-747d-9ec4-fff6a9696e05.webp",
      "image_media": {
        "alt_text": "Bedroom with TV, desk, and closet.",
        "public_id": "01a0b67a-9b07-747d-9ec4-fff6a9696e05",
        "storage_key": "property/6767906449167625/01a0b67a-9b07-747d-9ec4-fff6a9696e05.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a large flat-screen TV, a modern media console, a dedicated workspace with a desk and chair, and a convenient walk-in closet. Ceiling fan and ample natural light complete the inviting space.",
      "link": "false",
      "alt_text": "Bedroom with TV, desk, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-DSC05340_final.jpg"
    },
    {
      "id": "ec_761aa07ed71123c01e5d41d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-9bf3-7719-a39a-87634bfc4ade.webp",
      "image_media": {
        "alt_text": "Modern living room with a white sofa, coffee table, and abstract art.",
        "public_id": "01a0b67a-9bf3-7719-a39a-87634bfc4ade",
        "storage_key": "property/6767906449167625/01a0b67a-9bf3-7719-a39a-87634bfc4ade.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A bright and airy living room featuring a comfortable white sofa, a stylish coffee table, and contemporary wall art, perfect for relaxation.",
      "link": "false",
      "alt_text": "Modern living room with a white sofa, coffee table, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-DSC05290_ver_final.jpg"
    },
    {
      "id": "ec_f97adb7fd86c94d8f6fc888a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-89db-7368-a8ec-c894175c2b30.webp",
      "image_media": {
        "alt_text": "Modern living room with a white sofa, abstract art, and vertical blinds.",
        "public_id": "01a0b67a-89db-7368-a8ec-c894175c2b30",
        "storage_key": "property/6767906449167625/01a0b67a-89db-7368-a8ec-c894175c2b30.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this stylish living space featuring a comfortable white sofa, contemporary artwork, and ample natural light streaming through vertical blinds.",
      "link": "false",
      "alt_text": "Modern living room with a white sofa, abstract art, and vertical blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-DSC05290_final.jpg"
    },
    {
      "id": "ec_1e8adf053a48d4f0f004ab52",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-a2c2-754a-b86d-2a9a5e03b9ca.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, dining area, and kitchen pass-through with bar stools.",
        "public_id": "01a0b67a-a2c2-754a-b86d-2a9a5e03b9ca",
        "storage_key": "property/6767906449167625/01a0b67a-a2c2-754a-b86d-2a9a5e03b9ca.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, a dining area, and a pass-through kitchen with bar seating, perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room with fireplace, dining area, and kitchen pass-through with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-DSC05275_final.jpg"
    },
    {
      "id": "ec_b35d32d1369ba8673c55a957",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-aacf-72c8-abf9-d79183337cef.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, oven, microwave, and doorway to bedroom.",
        "public_id": "01a0b67a-aacf-72c8-abf9-d79183337cef",
        "storage_key": "property/6767906449167625/01a0b67a-aacf-72c8-abf9-d79183337cef.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "View of a kitchen featuring wooden cabinets, a stove, microwave, and a doorway leading to a bedroom.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, oven, microwave, and doorway to bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/4-9250 Lichtenauer Dr-4.jpg"
    },
    {
      "id": "ec_4875d694a1de3504d556fc0b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-ba4c-747c-a938-cc6751eea4f2.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, ceiling fan, and closet.",
        "public_id": "01a0b67a-ba4c-747c-a938-cc6751eea4f2",
        "storage_key": "property/6767906449167625/01a0b67a-ba4c-747c-a938-cc6751eea4f2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, a ceiling fan for air circulation, and a convenient walk-in closet.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, ceiling fan, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-DSC05325_final.jpg"
    },
    {
      "id": "ec_db89f37eac5f7c93a2f398c2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-a896-739e-a7aa-384c0642866a.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, black stove, microwave, and refrigerator.",
        "public_id": "01a0b67a-a896-739e-a7aa-384c0642866a",
        "storage_key": "property/6767906449167625/01a0b67a-a896-739e-a7aa-384c0642866a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A functional kitchen featuring wooden cabinets, a black stove, microwave, and refrigerator, perfect for everyday use.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, black stove, microwave, and refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/2-9250 Lichtenauer Dr-2.jpg"
    },
    {
      "id": "ec_a1af35fe021c2e658d434245",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-c22d-7468-a34d-7f9fc9f1359d.webp",
      "image_media": {
        "alt_text": "Bathroom with white tiled shower, toilet, and vanity with granite countertop.",
        "public_id": "01a0b67a-c22d-7468-a34d-7f9fc9f1359d",
        "storage_key": "property/6767906449167625/01a0b67a-c22d-7468-a34d-7f9fc9f1359d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a well-appointed bathroom featuring a bathtub/shower combo, a toilet, and a vanity with ample counter space.",
      "link": "false",
      "alt_text": "Bathroom with white tiled shower, toilet, and vanity with granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-DSC05345_final.jpg"
    },
    {
      "id": "ec_7fadfdc5e4d299ae8a2f66c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-c9e4-731c-9d77-8c0fd7027e8d.webp",
      "image_media": {
        "alt_text": "Balcony with a table set for drinks and a plant.",
        "public_id": "01a0b67a-c9e4-731c-9d77-8c0fd7027e8d",
        "storage_key": "property/6767906449167625/01a0b67a-c9e4-731c-9d77-8c0fd7027e8d.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening drinks on your private balcony, furnished with a table, chairs, and a charming plant.",
      "link": "false",
      "alt_text": "Balcony with a table set for drinks and a plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/23-DSC05361_final.jpg"
    },
    {
      "id": "ec_276bf66cb65c5deb51a245f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-bb81-7608-95a4-fc3e27745115.webp",
      "image_media": {
        "alt_text": "Picnic tables and grills near a tennis court.",
        "public_id": "01a0b67a-bb81-7608-95a4-fc3e27745115",
        "storage_key": "property/6767906449167625/01a0b67a-bb81-7608-95a4-fc3e27745115.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy outdoor dining with picnic tables and grills, conveniently located near the tennis courts.",
      "link": "false",
      "alt_text": "Picnic tables and grills near a tennis court.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/5WRL_Amenities_9.jpg"
    },
    {
      "id": "ec_25a6117eebaaaa9864a658b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-c255-74ac-8315-8a6c27c3e1d7.webp",
      "image_media": {
        "alt_text": "Tennis courts with nets and fencing, surrounded by trees and a parking lot.",
        "public_id": "01a0b67a-c255-74ac-8315-8a6c27c3e1d7",
        "storage_key": "property/6767906449167625/01a0b67a-c255-74ac-8315-8a6c27c3e1d7.webp",
        "width": 1246,
        "height": 831
      },
      "title": "Community",
      "description": "Enjoy a game of tennis on our well-maintained courts, perfect for residents looking to stay active and have fun.",
      "link": "false",
      "alt_text": "Tennis courts with nets and fencing, surrounded by trees and a parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/5WRL_Amenities_30.jpg"
    },
    {
      "id": "ec_815ddafebe83ce75198b2728",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc990-38c4-763c-a2cd-6746c128553a.webp",
      "image_media": {
        "alt_text": "Outdoor seating area next to a swimming pool at dusk.",
        "public_id": "019fc990-38c4-763c-a2cd-6746c128553a",
        "storage_key": "property/6767906449167625/019fc990-38c4-763c-a2cd-6746c128553a.webp",
        "width": 1008,
        "height": 672
      },
      "title": "Community",
      "description": "Relax in the covered outdoor seating area adjacent to the sparkling swimming pool, perfect for unwinding at dusk.",
      "link": "false",
      "alt_text": "Outdoor seating area next to a swimming pool at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/9250 lichtenauer dr-11 copy (1) (1).jpg"
    },
    {
      "id": "ec_ed44b4733da4ca6e36ee086a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-cd5f-70de-aa1a-87171691a8f8.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and a covered cabana.",
        "public_id": "01a0b67a-cd5f-70de-aa1a-87171691a8f8",
        "storage_key": "property/6767906449167625/01a0b67a-cd5f-70de-aa1a-87171691a8f8.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling resort-style swimming pool, complete with comfortable lounge chairs and a shaded cabana area perfect for sunny afternoons.",
      "link": "false",
      "alt_text": "Resort-style pool with lounge chairs and a covered cabana.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/5WRL_Amenities_4.jpg"
    },
    {
      "id": "ec_7b856d05b141d97b6f621227",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-e188-7238-b458-604bcf585c20.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with grey cabinets, stainless steel appliances, and a large black dining table with blue chairs.",
        "public_id": "01a0b67a-e188-7238-b458-604bcf585c20",
        "storage_key": "property/6767906449167625/01a0b67a-e188-7238-b458-604bcf585c20.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy a stylish and functional kitchen and dining space, perfect for preparing meals and entertaining guests.",
      "link": "false",
      "alt_text": "Modern kitchen and dining area with grey cabinets, stainless steel appliances, and a large black dining table with blue chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/9250 Lichtenauer Dr-4.jpg"
    },
    {
      "id": "ec_9617041628269ea8f5a63d9c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-e185-743e-915f-24c2c2d22be4.webp",
      "image_media": {
        "alt_text": "Treadmills, ellipticals, and stationary bikes in a well-lit fitness center with mirrors.",
        "public_id": "01a0b67a-e185-743e-915f-24c2c2d22be4",
        "storage_key": "property/6767906449167625/01a0b67a-e185-743e-915f-24c2c2d22be4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines like treadmills, ellipticals, and stationary bikes.",
      "link": "false",
      "alt_text": "Treadmills, ellipticals, and stationary bikes in a well-lit fitness center with mirrors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/9250 Lichtenauer Dr-7.jpg"
    },
    {
      "id": "ec_9c5735150cb81e6a1e8081a9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-e946-731f-b277-4bfdda5c8e48.webp",
      "image_media": {
        "alt_text": "Reception area with desks, computers, and abstract art.",
        "public_id": "01a0b67a-e946-731f-b277-4bfdda5c8e48",
        "storage_key": "property/6767906449167625/01a0b67a-e946-731f-b277-4bfdda5c8e48.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Welcome to our leasing office, a modern and inviting space designed for your comfort and convenience. Featuring contemporary art and a streamlined workspace.",
      "link": "false",
      "alt_text": "Reception area with desks, computers, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/9250 Lichtenauer Dr-1.jpg"
    },
    {
      "id": "ec_ca41fe3858dd676f700f2600",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-d7e9-714c-96f9-80e928af170a.webp",
      "image_media": {
        "alt_text": "Dining area and open-concept living room with kitchen view.",
        "public_id": "01a0b67a-d7e9-714c-96f9-80e928af170a",
        "storage_key": "property/6767906449167625/01a0b67a-d7e9-714c-96f9-80e928af170a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and airy living space with dining area, breakfast bar, and modern kitchen. Perfect for entertaining and everyday living.",
      "link": "false",
      "alt_text": "Dining area and open-concept living room with kitchen view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-9_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_5202edaa7f7b1ae5d8228046",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-f1c4-73a7-9c7a-9108cad6f773.webp",
      "image_media": {
        "alt_text": "Aerial view of a well-maintained multifamily property building with manicured lawns and landscaping.",
        "public_id": "01a0b67a-f1c4-73a7-9c7a-9108cad6f773",
        "storage_key": "property/6767906449167625/01a0b67a-f1c4-73a7-9c7a-9108cad6f773.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Discover this beautiful multifamily property with lush green spaces, attractive landscaping, and a welcoming building exterior. A perfect place to call home.",
      "link": "false",
      "alt_text": "Aerial view of a well-maintained multifamily property building with manicured lawns and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Drone-Photo_Leasing-Office-Exterior-1_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_c38cd1aebaf47ad7e76fd8dd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-2a2f-71bf-9f0e-6eb768fad94e.webp",
      "image_media": {
        "alt_text": "Aerial view of a sprawling apartment complex with multiple buildings, surrounding greenery, and a nearby highway.",
        "public_id": "01a0b67a-2a2f-71bf-9f0e-6eb768fad94e",
        "storage_key": "property/6767906449167625/01a0b67a-2a2f-71bf-9f0e-6eb768fad94e.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Experience comfortable living in this expansive apartment community, featuring ample green spaces, ponds, and convenient access to major roadways for easy commuting.",
      "link": "false",
      "alt_text": "Aerial view of a sprawling apartment complex with multiple buildings, surrounding greenery, and a nearby highway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Drone-Photo_Neighborhood-1_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_8bf087d74605ac3a572d3698",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-e0db-76e8-89fb-33491c976592.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with a paved walkway leading to the entrance.",
        "public_id": "01a0b67a-e0db-76e8-89fb-33491c976592",
        "storage_key": "property/6767906449167625/01a0b67a-e0db-76e8-89fb-33491c976592.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Charming exterior of the apartment building, featuring a welcoming paved walkway and lush green lawns.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with a paved walkway leading to the entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Exterior-Photo_Residential-Buildings-1_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_552faa59e919ada3610234c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-1fd3-726d-95ab-6a97a9caa868.webp",
      "image_media": {
        "alt_text": "Volleyball court and swimming pool area with lounge chairs.",
        "public_id": "01a0b67a-1fd3-726d-95ab-6a97a9caa868",
        "storage_key": "property/6767906449167625/01a0b67a-1fd3-726d-95ab-6a97a9caa868.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with a sand volleyball court and a sparkling swimming pool, perfect for relaxation and fun.",
      "link": "false",
      "alt_text": "Volleyball court and swimming pool area with lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Exterior-Photo_Volleyball-Court_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_b71965b1febadd70232df1be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67b-012c-7551-bc7b-9262892e2dfb.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with manicured lawn",
        "public_id": "01a0b67b-012c-7551-bc7b-9262892e2dfb",
        "storage_key": "property/6767906449167625/01a0b67b-012c-7551-bc7b-9262892e2dfb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Showcasing the exterior of the apartment complex with beautiful green spaces and well-maintained grounds.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with manicured lawn",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Exterior-Photo_Residential-Buildings-3_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_0ea804bc0b84ad15befdef85",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67b-0135-7230-acc5-f4b84c2907f2.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with red brick and grey siding, featuring balconies and manicured lawns.",
        "public_id": "01a0b67b-0135-7230-acc5-f4b84c2907f2",
        "storage_key": "property/6767906449167625/01a0b67b-0135-7230-acc5-f4b84c2907f2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Exterior view of a well-maintained apartment building, showcasing its architecture with red brick and grey siding. The property offers balconies and lush green spaces.",
      "link": "false",
      "alt_text": "Apartment building exterior with red brick and grey siding, featuring balconies and manicured lawns.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Exterior-Photo_Residential-Buildings-2_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_81ebacaf1c29a1d0276dc6b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67b-00de-7359-a8b9-5eff8814b188.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a swimming pool, and a highway in the background.",
        "public_id": "01a0b67b-00de-7359-a8b9-5eff8814b188",
        "storage_key": "property/6767906449167625/01a0b67b-00de-7359-a8b9-5eff8814b188.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Experience resort-style living at our apartment community, featuring a sparkling swimming pool and beautifully landscaped grounds. Enjoy convenient access to major highways for easy commuting.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a swimming pool, and a highway in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Drone-Photo_Neighborhood-2_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_2da0045d01015d7b5dbc78e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-f387-725f-b3f6-896896f1a3d1.webp",
      "image_media": {
        "alt_text": "Patio with table and chairs outside apartment building.",
        "public_id": "01a0b67a-f387-725f-b3f6-896896f1a3d1",
        "storage_key": "property/6767906449167625/01a0b67a-f387-725f-b3f6-896896f1a3d1.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Enjoy outdoor living on your private patio, complete with a table and chairs, perfect for al fresco dining.",
      "link": "false",
      "alt_text": "Patio with table and chairs outside apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-13_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_e24ec096ba762c78db8e79ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-4cc2-730c-9578-006bd9e3207f.webp",
      "image_media": {
        "alt_text": "Covered patio with a table and chairs overlooking a grassy area and apartment buildings.",
        "public_id": "01a0b67a-4cc2-730c-9578-006bd9e3207f",
        "storage_key": "property/6767906449167625/01a0b67a-4cc2-730c-9578-006bd9e3207f.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation on your private covered patio, offering views of the community grounds and apartment buildings.",
      "link": "false",
      "alt_text": "Covered patio with a table and chairs overlooking a grassy area and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-14_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_eadca0737baf6dc60c51b1ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-3511-774d-b9f9-77f9203d9d94.webp",
      "image_media": {
        "alt_text": "Laundry room with stacked washers and dryers, and additional front-loading washers.",
        "public_id": "01a0b67a-3511-774d-b9f9-77f9203d9d94",
        "storage_key": "property/6767906449167625/01a0b67a-3511-774d-b9f9-77f9203d9d94.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with multiple washers and dryers for resident use.",
      "link": "false",
      "alt_text": "Laundry room with stacked washers and dryers, and additional front-loading washers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Interior-Photo_Laundry-Facility_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_11c9296fb475c306b0b409e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-fd42-73dc-b65a-b64bb789f044.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, stainless steel appliances including a microwave, oven, and refrigerator.",
        "public_id": "01a0b67a-fd42-73dc-b65a-b64bb789f044",
        "storage_key": "property/6767906449167625/01a0b67a-fd42-73dc-b65a-b64bb789f044.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Apartment",
      "description": "A modern kitchen featuring white cabinetry, granite countertops, and stainless steel appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, granite countertops, stainless steel appliances including a microwave, oven, and refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-8_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_ddb3e5386d5f423d970ba60c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-fda1-72c8-9bcb-dd0a61342dde.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "01a0b67a-fda1-72c8-9bcb-dd0a61342dde",
        "storage_key": "property/6767906449167625/01a0b67a-fda1-72c8-9bcb-dd0a61342dde.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "This apartment kitchen features ample cabinet space, granite countertops, and a full suite of appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-3_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_a155691b0c3eb2b027a366bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67b-07bc-755e-9de6-fe80ef5c9716.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with a pool, clubhouse, and surrounding apartment buildings.",
        "public_id": "01a0b67b-07bc-755e-9de6-fe80ef5c9716",
        "storage_key": "property/6767906449167625/01a0b67b-07bc-755e-9de6-fe80ef5c9716.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Spacious community amenities including a sparkling swimming pool and a well-appointed clubhouse, set against a backdrop of apartment buildings and lush landscaping.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily property with a pool, clubhouse, and surrounding apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Drone-Photo_Leasing-Office-Exterior-2_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_7366e61a29e74a44ca559818",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-3cd8-763a-a2b7-fb243ebc4916.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances and granite countertops.",
        "public_id": "01a0b67a-3cd8-763a-a2b7-fb243ebc4916",
        "storage_key": "property/6767906449167625/01a0b67a-3cd8-763a-a2b7-fb243ebc4916.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space. Overlooks a courtyard area.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel appliances and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-7_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_4b149c5c4bc1c8d2902632ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67b-202f-71d9-a641-bd1c1405c416.webp",
      "image_media": {
        "alt_text": "Living room and dining area of an apartment, with a kitchen visible in the background.",
        "public_id": "01a0b67b-202f-71d9-a641-bd1c1405c416",
        "storage_key": "property/6767906449167625/01a0b67b-202f-71d9-a641-bd1c1405c416.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into this inviting living and dining area, seamlessly connected to a functional kitchen. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room and dining area of an apartment, with a kitchen visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-1_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_bb0dcbbf1adae9194c170e30",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67b-0f61-73ce-bd4f-e8b8a43c0f82.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment",
        "public_id": "01a0b67b-0f61-73ce-bd4f-e8b8a43c0f82",
        "storage_key": "property/6767906449167625/01a0b67b-0f61-73ce-bd4f-e8b8a43c0f82.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area with modern appliances and furnishings.",
      "link": "false",
      "alt_text": "Living room and kitchen area of an apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-11_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_be671637ed215155c8fb508f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-4c7d-77ed-923c-82422cabb837.webp",
      "image_media": {
        "alt_text": "Dining area and living room in apartment with light-colored walls, wood floors, and modern furniture.",
        "public_id": "01a0b67a-4c7d-77ed-923c-82422cabb837",
        "storage_key": "property/6767906449167625/01a0b67a-4c7d-77ed-923c-82422cabb837.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious dining and living area featuring a breakfast bar, comfortable seating, and contemporary decor, perfect for entertaining guests.",
      "link": "false",
      "alt_text": "Dining area and living room in apartment with light-colored walls, wood floors, and modern furniture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-10_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_9c2c353eebcb5257d0e55f22",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67b-0fac-726a-bb33-a19a2ced75e1.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment.",
        "public_id": "01a0b67b-0fac-726a-bb33-a19a2ced75e1",
        "storage_key": "property/6767906449167625/01a0b67b-0fac-726a-bb33-a19a2ced75e1.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish dining area and kitchen with ample cabinet space in an apartment.",
      "link": "false",
      "alt_text": "Dining area and kitchen in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-2_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_d54e18f2cdffd8c873eeb21b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67b-1007-76dd-991c-82fd5d56cc67.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "01a0b67b-1007-76dd-991c-82fd5d56cc67",
        "storage_key": "property/6767906449167625/01a0b67b-1007-76dd-991c-82fd5d56cc67.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Clean and functional bathroom featuring a vanity with granite countertop, a toilet, and a bathtub with a patterned shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-5_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_7512cc0c358b999fff33d05a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-33d6-76e8-b43d-df8ee58ed1a6.webp",
      "image_media": {
        "alt_text": "Kitchen and laundry room with washing machines.",
        "public_id": "01a0b67a-33d6-76e8-b43d-df8ee58ed1a6",
        "storage_key": "property/6767906449167625/01a0b67a-33d6-76e8-b43d-df8ee58ed1a6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A view of a kitchen with a refrigerator and oven, adjacent to a laundry room featuring two washing machines and storage baskets.",
      "link": "false",
      "alt_text": "Kitchen and laundry room with washing machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-6_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_72c418c9d131114029805104",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67b-2797-7799-9208-2c1b2b95fa2c.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower.",
        "public_id": "01a0b67b-2797-7799-9208-2c1b2b95fa2c",
        "storage_key": "property/6767906449167625/01a0b67b-2797-7799-9208-2c1b2b95fa2c.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a speckled countertop, a toilet, and a bathtub/shower combination with a decorative curtain.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-12_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_c561c5fec716496778d3d822",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-54db-757b-bde0-88e9db4209c1.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances, wood cabinets, and granite countertops.",
        "public_id": "01a0b67a-54db-757b-bde0-88e9db4209c1",
        "storage_key": "property/6767906449167625/01a0b67a-54db-757b-bde0-88e9db4209c1.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring black appliances, ample wood cabinetry, and granite countertops.",
      "link": "false",
      "alt_text": "Kitchen with black appliances, wood cabinets, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Staged-Photo_Apartment-Interior-4_2026-07-14_MLS-Size.jpg"
    },
    {
      "id": "ec_12efc29501d4318506937fb1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-1f44-718e-be41-12f3269ec1fa.webp",
      "image_media": {
        "alt_text": "Covered parking spaces with cars parked in them.",
        "public_id": "01a0b67a-1f44-718e-be41-12f3269ec1fa",
        "storage_key": "property/6767906449167625/01a0b67a-1f44-718e-be41-12f3269ec1fa.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Covered parking spaces available for residents, offering protection from the elements.",
      "link": "false",
      "alt_text": "Covered parking spaces with cars parked in them.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Wind-River-Lodge-047_Exterior-Photo_Carports_2026-07-14_MLS-Size.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1e14a997-4331-471c-85f7-ad89af5fbd34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Sierra Grill",
      "poi_type": "Restaurants",
      "poi_address": "8659 Penrose Ln, Lenexa, KS 66219, USA",
      "poi_short_description": "Laid-back steakhouse offering grilled steak, chicken & seafood, plus wine & specialty cocktails.",
      "poi_long_description": "Laid-back steakhouse offering grilled steak, chicken & seafood, plus wine & specialty cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc993-bcb9-700d-afa0-0b69eec3d2ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-bcb9-700d-afa0-0b69eec3d2ff",
        "storage_key": "property/6767906449167625/019fc993-bcb9-700d-afa0-0b69eec3d2ff.webp",
        "width": 1280,
        "height": 1212
      },
      "poi_business_url": "http://sierragrillkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9376761955747932456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sierra-grill",
      "poi_latitude": "38.9719805",
      "poi_longitude": "-94.7835995",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-599-3555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm5ykZgOVwIcRKKnAi1HzIII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a052e0f2-8f3d-4f33-9401-be4d7cded6df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Sierra BBQ",
      "poi_type": "Restaurants",
      "poi_address": "11099 Lackman Rd, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-0419-74f1-b4a7-e8b4582f1854.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-0419-74f1-b4a7-e8b4582f1854",
        "storage_key": "property/6767906449167625/01a0b672-0419-74f1-b4a7-e8b4582f1854.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://sierrabbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18264476481289494290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sierra-bbq",
      "poi_latitude": "38.9278703",
      "poi_longitude": "-94.7604422",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-599-3690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqQ4awrGVwIcREp-8I5d0eP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_be1fabcc-f949-4e58-9480-ee1e2ea9bc36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Maps Coffee & Chocolate",
      "poi_type": "Restaurants",
      "poi_address": "13440 Santa Fe Trail Dr, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-32af-709a-8e92-3463d5f85a4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-32af-709a-8e92-3463d5f85a4f",
        "storage_key": "property/6767906449167625/019ff6a3-32af-709a-8e92-3463d5f85a4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mapscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13627249561221263583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maps-coffee--chocolate",
      "poi_latitude": "38.96073070000001",
      "poi_longitude": "-94.74189",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-444-5252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuRqhv7uUwIcR3_Awkka3Hb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_roastery"
    },
    {
      "id": "custom_3d27c830-c9d3-4549-9761-3a52cf2a3acf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Brewbakers Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "9482 Renner Blvd, Lenexa, KS 66219, USA",
      "poi_short_description": "Relaxed haunt featuring American comfort eats & many craft beers on tap, plus TVs tuned to sports.",
      "poi_long_description": "Relaxed haunt featuring American comfort eats & many craft beers on tap, plus TVs tuned to sports.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-2786-70b8-9ab8-70f647823721.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-2786-70b8-9ab8-70f647823721",
        "storage_key": "property/6767906449167625/019ff6a3-2786-70b8-9ab8-70f647823721.webp",
        "width": 1080,
        "height": 596
      },
      "poi_business_url": "http://brewbakersbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15540634894649098230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brewbakers-bar--grill",
      "poi_latitude": "38.9569524",
      "poi_longitude": "-94.7806315",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-261-9515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNTGRVm-UwIcR9n-ZTxltq9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_7ef91b7d-c9a0-4a61-897a-db9b7f715290",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "China Star",
      "poi_type": "Restaurants",
      "poi_address": "9337 Harbinger St, Lenexa, KS 66219, USA",
      "poi_short_description": "Informal, cozy spot whipping up familiar Chinese eats, including Mongolian beef, orange chicken, and crab rangoon.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b671-fc41-7256-a6a4-96303c0989f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-fc41-7256-a6a4-96303c0989f4",
        "storage_key": "property/6767906449167625/01a0b671-fc41-7256-a6a4-96303c0989f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chinastarlenexaks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18169869968859307113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-star",
      "poi_latitude": "38.9592935",
      "poi_longitude": "-94.7803471",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-400-2239",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOUoT2XKVwIcRaZzl9HdYKPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_c237ec42-8012-4741-b0ab-037d7949e8d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Shack Breakfast & Lunch - Lenexa",
      "poi_type": "Restaurants",
      "poi_address": "9329 Harbinger St, Lenexa, KS 66219, USA",
      "poi_short_description": "Casual, modern, rustic eatery serving traditional breakfast staples plus specialty dishes for brunch.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc993-a66a-76de-a45c-3ea695ca1398.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-a66a-76de-a45c-3ea695ca1398",
        "storage_key": "property/6767906449167625/019fc993-a66a-76de-a45c-3ea695ca1398.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.eatatshack.com/?y_source=1_MjMzODcxNzgtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9249565460053893250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shack-breakfast--lunch---lenexa",
      "poi_latitude": "38.9595412",
      "poi_longitude": "-94.7802919",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-549-4808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmaycMpiTwIcRgiA8lccOXYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_ae7aac2f-16ab-40c1-9176-e63357b89bf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Pegah's Family Restaurant- W 87th St",
      "poi_type": "Restaurants",
      "poi_address": "12122 W 87th St, Lenexa, KS 66215, USA",
      "poi_short_description": "Casual, family-friendly kitchen serving American comfort classics like burgers, omelets & waffles.",
      "poi_long_description": "Casual, family-friendly kitchen serving American comfort classics like burgers, omelets & waffles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b671-fbee-77be-913e-e7db8245f789.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-fbee-77be-913e-e7db8245f789",
        "storage_key": "property/6767906449167625/01a0b671-fbee-77be-913e-e7db8245f789.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pegahs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16860098608616263608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pegahs-family-restaurant--w-87th-st",
      "poi_latitude": "38.97160290000001",
      "poi_longitude": "-94.7267781",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-258-8766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmbllvVTrwIcRuE-hHFsa--k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "custom_99c76b28-5d59-47ef-95e4-a309030449b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Grand Street Lenexa",
      "poi_type": "Restaurants",
      "poi_address": "8815 Renner Blvd, Lenexa, KS 66219, USA",
      "poi_short_description": "Dining destination offering elevated American fare & a lengthy wine list in a contemporary setting.",
      "poi_long_description": "Dining destination offering elevated American fare & a lengthy wine list in a contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc994-6d3f-74b8-b2ae-0d25f0d4d001.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-6d3f-74b8-b2ae-0d25f0d4d001",
        "storage_key": "property/6767906449167625/019fc994-6d3f-74b8-b2ae-0d25f0d4d001.webp",
        "width": 1280,
        "height": 657
      },
      "poi_business_url": "http://grandstreetlenexa.com/menus",
      "poi_directions_map_url": "https://maps.google.com/?cid=4288467701067941316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-street-lenexa",
      "poi_latitude": "38.9685061",
      "poi_longitude": "-94.7788194",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-601-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLU7XoHCUwIcRxAXkIKeygzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_57a014f5-c3f1-4774-8386-083ffdd24a29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Sushi UNI",
      "poi_type": "Restaurants",
      "poi_address": "12841 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "Compact, busy strip-mall venue for traditional Japanese sushi, sashimi, salads & hot entrees.",
      "poi_long_description": "Compact, busy strip-mall venue for traditional Japanese sushi, sashimi, salads & hot entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc994-6a86-711a-be41-dcc42d3b1f48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-6a86-711a-be41-dcc42d3b1f48",
        "storage_key": "property/6767906449167625/019fc994-6a86-711a-be41-dcc42d3b1f48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sushiunikc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2788749059343652231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-uni",
      "poi_latitude": "38.9703578",
      "poi_longitude": "-94.7351629",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-322-8667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWQVgBqmUwIcRhxXieX6gsyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_31081616-ea11-4d1d-ad7b-325cc3f047c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Chartroose Caboose",
      "poi_type": "Restaurants",
      "poi_address": "12976 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "Casual restaurant known for Philly cheesesteaks and burgers plus hoagies, and ice cream.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b671-fb94-73a9-85c5-cdffeb85f07a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-fb94-73a9-85c5-cdffeb85f07a",
        "storage_key": "property/6767906449167625/01a0b671-fb94-73a9-85c5-cdffeb85f07a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://chartroosecaboosekc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5938671651070160249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chartroose-caboose",
      "poi_latitude": "38.9714934",
      "poi_longitude": "-94.7363342",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-660-0180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ370TwaiUwIcReS2492ZmalI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c6a73edf-743c-4ccc-81af-373f03849cc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Black Dog Coffeehouse",
      "poi_type": "Restaurants",
      "poi_address": "12815 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "Cozy cafe with a meeting area & free WiFi offering basic & specialty coffee drinks, plus light eats.",
      "poi_long_description": "Cozy cafe with a meeting area & free WiFi offering basic & specialty coffee drinks, plus light eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-30f0-7319-bf77-f6257d342ce4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-30f0-7319-bf77-f6257d342ce4",
        "storage_key": "property/6767906449167625/019ff6a3-30f0-7319-bf77-f6257d342ce4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bdcoffeehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6894298284460462094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-dog-coffeehouse",
      "poi_latitude": "38.9703342",
      "poi_longitude": "-94.7343619",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-495-5515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-401d-70de-8f4a-2d6e4e7b7991.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-401d-70de-8f4a-2d6e4e7b7991",
        "storage_key": "property/6767906449167625/019ff6a4-401d-70de-8f4a-2d6e4e7b7991.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJW4FqNKmUwIcRDtDZHMN3rV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_5dded146-615a-4cd2-a2cc-f7975e050feb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Tupelo Honey Southern Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "16720 City Center Dr, Lenexa, KS 66219, USA",
      "poi_short_description": "An all-day menu of Southern comfort food with a creative twist, plus craft beers & cocktails.",
      "poi_long_description": "An all-day menu of Southern comfort food with a creative twist, plus craft beers & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b671-fc4d-704d-b2b0-f921cd2bfd60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-fc4d-704d-b2b0-f921cd2bfd60",
        "storage_key": "property/6767906449167625/01a0b671-fc4d-704d-b2b0-f921cd2bfd60.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://tupelohoneycafe.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=7467157571181511213&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tupelo-honey-southern-kitchen--bar",
      "poi_latitude": "38.96928740000001",
      "poi_longitude": "-94.7801009",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-220-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcYJDQCVwIcRLYIkkD-soGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_6ea9d89d-9af8-4244-81a8-ca3e9305111d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Martin City Brewing Co. Pizza & Taproom - Lenexa",
      "poi_type": "Restaurants",
      "poi_address": "8802 Renner Blvd, Lenexa, KS 66219, USA",
      "poi_short_description": "Casual family-friendly beer specialist with a pizzeria, serving a menu of beers on tap, cocktails, burgers, salads and pretzels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-3742-7528-8277-f993ee705655.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-3742-7528-8277-f993ee705655",
        "storage_key": "property/6767906449167625/019ff6a3-3742-7528-8277-f993ee705655.webp",
        "width": 1280,
        "height": 625
      },
      "poi_business_url": "http://martincitybrewingcompany.com/locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=15064962677990831093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martin-city-brewing-co-pizza--taproom---lenexa",
      "poi_latitude": "38.9687965",
      "poi_longitude": "-94.7801528",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-434-6086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSNNnp2VwIcR9TMp8Lx_EdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9ee2fbfc-dfe1-47b0-b395-6d2f824661da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Enjoy Pure Food + Drink",
      "poi_type": "Restaurants",
      "poi_address": "8729 Scarborough St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-00f0-7347-ae13-d381e687ab99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-00f0-7347-ae13-d381e687ab99",
        "storage_key": "property/6767906449167625/01a0b672-00f0-7347-ae13-d381e687ab99.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://enjoypurefood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12858218293445758583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enjoy-pure-food--drink",
      "poi_latitude": "38.9696882",
      "poi_longitude": "-94.781239",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-248-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpf3LMpSVwIcRd45DgWmRcbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3406024a-e014-44f8-b9e0-3add1d164217",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Jack Stack Barbecue - Lenexa",
      "poi_type": "Restaurants",
      "poi_address": "8721 Ryckert St, Lenexa, KS 66219, USA",
      "poi_short_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_long_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-0223-776f-b8ec-a08415833007.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-0223-776f-b8ec-a08415833007",
        "storage_key": "property/6767906449167625/01a0b672-0223-776f-b8ec-a08415833007.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jackstackbbq.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=3471442925309378532&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-stack-barbecue---lenexa",
      "poi_latitude": "38.9695267",
      "poi_longitude": "-94.7778048",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-382-4227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZae_a5eVwIcR5L8btfIKLTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_f24a848d-a82b-4bef-afe5-da21b7036341",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Casey's General Store",
      "poi_type": "Transportation & Transit",
      "poi_address": "9350 Renner Rd, Lenexa, KS 66219, USA",
      "poi_short_description": "Convenience store and gas station offering pizza and other food items, plus a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a01009-fe88-7204-ba58-412577011d9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01009-fe88-7204-ba58-412577011d9b",
        "storage_key": "property/6767906449167625/01a01009-fe88-7204-ba58-412577011d9b.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "https://www.caseys.com/general-store/ks-lenexa/9350-renner-blvd/4202",
      "poi_directions_map_url": "https://maps.google.com/?cid=13214550645275427476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caseys-general-store",
      "poi_latitude": "38.9581251",
      "poi_longitude": "-94.7804241",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-710-1542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0100a-1b8f-7029-a8b3-90d5000b89d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0100a-1b8f-7029-a8b3-90d5000b89d6",
        "storage_key": "property/6767906449167625/01a0100a-1b8f-7029-a8b3-90d5000b89d6.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8qgTm-UwIcRlAINVsyDY7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_fe3050f9-fcbc-48aa-a35f-64b20707dce3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Lenexa Public Market",
      "poi_type": "Restaurants",
      "poi_address": "8750 Penrose Ln, Lenexa, KS 66219, USA",
      "poi_short_description": "Hip venue with trendy eateries & communal seating, plus small local merchants for clothing & more.",
      "poi_long_description": "Hip venue with trendy eateries & communal seating, plus small local merchants for clothing & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc994-512f-737d-84dc-8166d0079471.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-512f-737d-84dc-8166d0079471",
        "storage_key": "property/6767906449167625/019fc994-512f-737d-84dc-8166d0079471.webp",
        "width": 1280,
        "height": 767
      },
      "poi_business_url": "http://www.lenexapublicmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10083005860736764828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lenexa-public-market",
      "poi_latitude": "38.9699268",
      "poi_longitude": "-94.7837294",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-477-7516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIbehyHaUwIcRnItlhWgI7os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_court"
    },
    {
      "id": "custom_971b909b-0fcf-4324-816e-41314def9a0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "8550 Maurer Rd, Lenexa, KS 66219, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-3d94-715d-bd0d-c554c3ee4592.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-3d94-715d-bd0d-c554c3ee4592",
        "storage_key": "property/6767906449167625/019ff6a3-3d94-715d-bd0d-c554c3ee4592.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://sprouts.com/store/ks/lenexa/lenexa",
      "poi_directions_map_url": "https://maps.google.com/?cid=18116198236188620164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "38.972975",
      "poi_longitude": "-94.772813",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-312-1586",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-4019-741c-a4bc-eb10b76442c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-4019-741c-a4bc-eb10b76442c2",
        "storage_key": "property/6767906449167625/019ff6a4-4019-741c-a4bc-eb10b76442c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi7IxC3-UwIcRhLWU5E-qafs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7b41796f-b7d4-444f-9944-9d4e252d3182",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "15751 W 87th St, Lenexa, KS 66219, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc994-1301-7401-b76c-6c73cb49c4e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-1301-7401-b76c-6c73cb49c4e4",
        "storage_key": "property/6767906449167625/019fc994-1301-7401-b76c-6c73cb49c4e4.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ks/lenexa/15751-w-87th-street-parkway/f304",
      "poi_directions_map_url": "https://maps.google.com/?cid=9937914090544876237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.96989200000001",
      "poi_longitude": "-94.768913",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-4019-741c-a4bc-eb10b76442c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-4019-741c-a4bc-eb10b76442c2",
        "storage_key": "property/6767906449167625/019ff6a4-4019-741c-a4bc-eb10b76442c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwQwvoYCUwIcRzcpGRzaQ6ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_ac0df4df-8f7b-48ac-b958-947dc33617ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "13400 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "Neighborhood grocery store chain with a bakery, pharmacy and deli section.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc994-0a19-7426-a282-689176acce46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-0a19-7426-a282-689176acce46",
        "storage_key": "property/6767906449167625/019fc994-0a19-7426-a282-689176acce46.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=88&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3848803178573539019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.9722951",
      "poi_longitude": "-94.7411834",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-438-8308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-4019-741c-a4bc-eb10b76442c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-4019-741c-a4bc-eb10b76442c2",
        "storage_key": "property/6767906449167625/019ff6a4-4019-741c-a4bc-eb10b76442c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4nU7KaUwIcRyyZFXRmyaTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_61784aab-fcce-4a87-9ab1-08b065aa8e45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Hen House Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "15000 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "Grocery store featuring a salad bar along with house-made and organic goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-5f27-7234-8252-a4b1cb990dba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-5f27-7234-8252-a4b1cb990dba",
        "storage_key": "property/6767906449167625/019ff6a3-5f27-7234-8252-a4b1cb990dba.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://henhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14200189744630429157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hen-house-market",
      "poi_latitude": "38.9724477",
      "poi_longitude": "-94.7597369",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-599-6423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-4019-741c-a4bc-eb10b76442c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-4019-741c-a4bc-eb10b76442c2",
        "storage_key": "property/6767906449167625/019ff6a4-4019-741c-a4bc-eb10b76442c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJae5kJYOUwIcR5XXXP1Y1EcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_18b8b3b3-d8cb-4375-b160-b45055f10b50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "9350 Marshall Dr, Lenexa, KS 66215, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc995-179f-7409-9728-8d7de6398162.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-179f-7409-9728-8d7de6398162",
        "storage_key": "property/6767906449167625/019fc995-179f-7409-9728-8d7de6398162.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/lenexa-KS-349.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=1564556256895062367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "38.958711",
      "poi_longitude": "-94.733897",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-227-3703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-40ec-72d9-bce4-46eca1fdca66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40ec-72d9-bce4-46eca1fdca66",
        "storage_key": "property/6767906449167625/019ff6a4-40ec-72d9-bce4-46eca1fdca66.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJ59sp7aUwIcRX1FYU6BrthU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_f747ee39-9af4-47f5-8e82-2d0033fb2d59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "13502 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-b169-7568-a667-3ba9193e2bf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-b169-7568-a667-3ba9193e2bf1",
        "storage_key": "property/6767906449167625/019ff6a3-b169-7568-a667-3ba9193e2bf1.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/lenexa-ks-pharmacies/13502-west-87th-street-parkway-lenexa-ks-66215/storeid=5265?WT.mc_id=LS_GOOGLE_RX_5265",
      "poi_directions_map_url": "https://maps.google.com/?cid=10706818752355258298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.9717631",
      "poi_longitude": "-94.7430337",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-492-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-4b5d-775c-a50f-4498b1ebc33d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-4b5d-775c-a50f-4498b1ebc33d",
        "storage_key": "property/6767906449167625/019ff6a4-4b5d-775c-a50f-4498b1ebc33d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJebIe0qaUwIcRuk-gmO1ClpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_6829269e-7098-475a-8524-1b4a9d1cdbc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "15100 W 87th St Pkwy, Lenexa, KS 66219, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc994-1bbb-7716-9672-20f093380536.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-1bbb-7716-9672-20f093380536",
        "storage_key": "property/6767906449167625/019fc994-1bbb-7716-9672-20f093380536.webp",
        "width": 1280,
        "height": 655
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-15100+w+87th+street+pkwy-lenexa-ks-66219/id=4186",
      "poi_directions_map_url": "https://maps.google.com/?cid=15113763039521280157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.9717131",
      "poi_longitude": "-94.7617069",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-438-5172",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4Y-VIKUwIcRnRAYhmjfvtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_bca323a7-d8df-4b1a-a03e-39d9c668923e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Walmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "7701 Frontage Rd, Overland Park, KS 66204, USA",
      "poi_short_description": "Grocery and household goods are sold at this store, which also provides pharmacy services and optometric care.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-07d8-73af-a8e1-4ab68dc70847.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-07d8-73af-a8e1-4ab68dc70847",
        "storage_key": "property/6767906449167625/01a0b672-07d8-73af-a8e1-4ab68dc70847.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1691-overland-park-ks?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16580119918847404756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart",
      "poi_latitude": "38.9896418",
      "poi_longitude": "-94.6988084",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-648-5885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-40ec-72d9-bce4-46eca1fdca66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40ec-72d9-bce4-46eca1fdca66",
        "storage_key": "property/6767906449167625/019ff6a4-40ec-72d9-bce4-46eca1fdca66.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7Vm5UZDswIcR1CpHkDhrGOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_02388bab-7ab6-4bec-b6b5-e389f83731bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Sunflower Elementary School",
      "poi_type": "Education",
      "poi_address": "8955 Loiret Blvd, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc994-5893-7367-be2d-e9a4129ef966.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-5893-7367-be2d-e9a4129ef966",
        "storage_key": "property/6767906449167625/019fc994-5893-7367-be2d-e9a4129ef966.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://sunflower.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7638137545668298095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunflower-elementary-school",
      "poi_latitude": "38.9653822",
      "poi_longitude": "-94.7672302",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-993-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-2cd1767dcade",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQUmvuYeUwIcRbwUiE6EdAGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_34c1cc0a-8814-4934-b219-16486a10bade",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Lenexa Hills Elementary",
      "poi_type": "Education",
      "poi_address": "8650 Haven St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc994-6963-76fd-ae02-b32608a630dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-6963-76fd-ae02-b32608a630dc",
        "storage_key": "property/6767906449167625/019fc994-6963-76fd-ae02-b32608a630dc.webp",
        "width": 1280,
        "height": 632
      },
      "poi_business_url": "https://lenexahills.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9767865042949672121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lenexa-hills-elementary",
      "poi_latitude": "38.9719677",
      "poi_longitude": "-94.7945169",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-993-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-2cd1767dcade",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMU-AKpSTwIcRuYz4EoFtjoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_10974a7e-b794-4539-ad6a-85df88c60fe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Rosehill Elementary School",
      "poi_type": "Education",
      "poi_address": "9801 Rosehill Rd, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://rosehill.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11554316795495235630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosehill-elementary-school",
      "poi_latitude": "38.9504768",
      "poi_longitude": "-94.7313998",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-993-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-2cd1767dcade",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN0647MuUwIcRLsDSeegtWaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2e72027f-1c1d-4405-8650-eeaa802eeb45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Westridge Middle School",
      "poi_type": "Education",
      "poi_address": "9300 Nieman Rd, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-7be5-7674-944f-50554708be60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-7be5-7674-944f-50554708be60",
        "storage_key": "property/6767906449167625/019ff6a3-7be5-7674-944f-50554708be60.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://westridge.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=217242892534723488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westridge-middle-school",
      "poi_latitude": "38.9590348",
      "poi_longitude": "-94.7157697",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-993-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-2cd1767dcade",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk5xqEUbrwIcRoLOCf0LNAwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_88f15a55-df7c-4a74-941c-f1dd428af502",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Shawnee Mission West High School",
      "poi_type": "Education",
      "poi_address": "8800 W 85th St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc994-9793-7495-9124-ac61adb9015d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-9793-7495-9124-ac61adb9015d",
        "storage_key": "property/6767906449167625/019fc994-9793-7495-9124-ac61adb9015d.webp",
        "width": 1280,
        "height": 662
      },
      "poi_business_url": "http://smwest.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1174450894079124931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-mission-west-high-school",
      "poi_latitude": "38.9764917",
      "poi_longitude": "-94.688317",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-993-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-2cd1767dcade",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG5Gk03_rwIcRw-W5m918TBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_4793cc8c-4d86-4e4c-af67-aa84c6eaecb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Rise Above Early Learning Center",
      "poi_type": "Education",
      "poi_address": "9740 Rosehill Rd, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-0933-771f-b946-8a7dd05e0dd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-0933-771f-b946-8a7dd05e0dd1",
        "storage_key": "property/6767906449167625/01a0b672-0933-771f-b946-8a7dd05e0dd1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://riseaboveedu.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=949088335595306572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rise-above-early-learning-center",
      "poi_latitude": "38.9512718",
      "poi_longitude": "-94.7334457",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-495-9797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-2cd1767dcade",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeWQre8mUwIcRTP6fD9DWKw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_10491e10-2e71-463a-a110-d1e403fae6ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Children's Treehouse Learning Center",
      "poi_type": "Education",
      "poi_address": "8835 Monrovia, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-08f3-701e-a6f9-e2f6d69150e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-08f3-701e-a6f9-e2f6d69150e8",
        "storage_key": "property/6767906449167625/01a0b672-08f3-701e-a6f9-e2f6d69150e8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.childrenstreehouselc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5942719003441676900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-treehouse-learning-center",
      "poi_latitude": "38.9683943",
      "poi_longitude": "-94.7278065",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-871-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-2cd1767dcade",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk8TFz6yUwIcRZMIaoHLHeFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_3b1799e8-6790-4438-99e4-a974af6969da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "La Petite Academy of Lenexa",
      "poi_type": "Education",
      "poi_address": "15039 W 86th St, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-0b20-738b-8e38-4fb1cc13f5a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-0b20-738b-8e38-4fb1cc13f5a7",
        "storage_key": "property/6767906449167625/01a0b672-0b20-738b-8e38-4fb1cc13f5a7.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/lenexa-ks-7040/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7040",
      "poi_directions_map_url": "https://maps.google.com/?cid=7308822339508645587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-of-lenexa",
      "poi_latitude": "38.9728917",
      "poi_longitude": "-94.7607058",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-2cd1767dcade",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx7ObkgqUwIcR0y7aqDEnbmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_a17846cf-6129-4900-b7b7-c6c09f05a928",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc990-08c5-7648-9a32-8e40dfdfde15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc990-08c5-7648-9a32-8e40dfdfde15",
        "storage_key": "property/6767906449167625/019fc990-08c5-7648-9a32-8e40dfdfde15.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-2cd1767dcade",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_805e321c-6423-4f07-abff-9f41928a341f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Park University in Lenexa, KS",
      "poi_type": "Education",
      "poi_address": "17101 W 87th St Pkwy #201, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc994-b34d-708b-809a-2b50e40d57e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-b34d-708b-809a-2b50e40d57e3",
        "storage_key": "property/6767906449167625/019fc994-b34d-708b-809a-2b50e40d57e3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.park.edu/academics/explore-majors-programs/?location=ks-lenexa",
      "poi_directions_map_url": "https://maps.google.com/?cid=4175232509185359176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park-university-in-lenexa-ks",
      "poi_latitude": "38.9699706",
      "poi_longitude": "-94.7836795",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-888-0655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-2cd1767dcade",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ9_imnaUwIcRSP2nhNhn8Tk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7572ebf6-483b-49aa-b6f1-cae758485b8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Green Guitar Folk House",
      "poi_type": "Entertainment",
      "poi_address": "9400 Pflumm Rd, Lenexa, KS 66215, USA",
      "poi_short_description": "Live music venue hosting performances that range from heartfelt to hilarious.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-b0ab-76a9-b7ed-962b43a22d56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-b0ab-76a9-b7ed-962b43a22d56",
        "storage_key": "property/6767906449167625/019ff6a3-b0ab-76a9-b7ed-962b43a22d56.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.greenguitarfolk.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6048826680983489081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "green-guitar-folk-house",
      "poi_latitude": "38.9582868",
      "poi_longitude": "-94.7435931",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-805-5242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIcmotr6UwIcROQrte9G_8VM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_6b2848ca-3788-4fde-98bf-ee5db88de7a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Legler Barn Museum & Depot",
      "poi_type": "Entertainment",
      "poi_address": "14907 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-c0b4-768f-bb01-9d2f52797c8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-c0b4-768f-bb01-9d2f52797c8d",
        "storage_key": "property/6767906449167625/019ff6a3-c0b4-768f-bb01-9d2f52797c8d.webp",
        "width": 1280,
        "height": 792
      },
      "poi_business_url": "http://lenexa.com/leglerbarn",
      "poi_directions_map_url": "https://maps.google.com/?cid=18378601941004985886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legler-barn-museum--depot",
      "poi_latitude": "38.9705054",
      "poi_longitude": "-94.7592451",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-492-0038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-412b-77a9-bf4c-8f22e8b76645.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-412b-77a9-bf4c-8f22e8b76645",
        "storage_key": "property/6767906449167625/019ff6a4-412b-77a9-bf4c-8f22e8b76645.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJvfZ3rJyUwIcRHiboYRfpDf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_00e01ac1-9b8d-42c4-a2be-1f921231fb93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Kids Empire Lenexa",
      "poi_type": "Entertainment",
      "poi_address": "12124 W 95th St, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-1042-76d4-9c5c-15ce2a208894.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-1042-76d4-9c5c-15ce2a208894",
        "storage_key": "property/6767906449167625/01a0b672-1042-76d4-9c5c-15ce2a208894.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kidsempire.com/park/lenexa?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8178072222774041902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-empire-lenexa",
      "poi_latitude": "38.95914339999999",
      "poi_longitude": "-94.7262887",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-285-5834",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL-r4DQDrwIcRLp3veVtZfnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_playground"
    },
    {
      "id": "custom_3e44e022-7191-4e5d-a077-fe206d0bee51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Sar-Ko-Par Trails Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "and West 87th Street Parkway, Lackman Rd, Lenexa, KS 66215, USA",
      "poi_short_description": "Large park featuring trails, sports fields, a disc-golf course & playgrounds, plus a historic barn.",
      "poi_long_description": "Large park featuring trails, sports fields, a disc-golf course & playgrounds, plus a historic barn.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc992-ae85-74db-98f4-2bfc984d54de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-ae85-74db-98f4-2bfc984d54de",
        "storage_key": "property/6767906449167625/019fc992-ae85-74db-98f4-2bfc984d54de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Sar-Ko-Par-Trails-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2823848540526094805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sar-ko-par-trails-park",
      "poi_latitude": "38.9703123",
      "poi_longitude": "-94.7585845",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40e3-74c9-a099-efab022b1f4a",
        "storage_key": "property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWwHgcJyUwIcR1SmQRUlTMCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ee4ab1cb-e2c0-443d-b9d2-a22f7b09ecc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Shawnee Mission Park - Visitor Services",
      "poi_type": "Entertainment",
      "poi_address": "7900 Renner Rd Visitor Center, Shawnee, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc995-21b4-748a-b9b1-6a09bc9983eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-21b4-748a-b9b1-6a09bc9983eb",
        "storage_key": "property/6767906449167625/019fc995-21b4-748a-b9b1-6a09bc9983eb.webp",
        "width": 1280,
        "height": 635
      },
      "poi_business_url": "https://www.jcprd.com/606/Visitor-Services",
      "poi_directions_map_url": "https://maps.google.com/?cid=15068624074064684319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-mission-park---visitor-services",
      "poi_latitude": "38.9857532",
      "poi_longitude": "-94.7820515",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-438-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0oKYO-TwIcRH2WGJMKBHtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_ffdf5045-fb6e-49bb-ad3f-80d98df66de3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Cinemark Merriam and XD",
      "poi_type": "Entertainment",
      "poi_address": "5500 Antioch Dr, Merriam, KS 66202, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-10a1-74e0-80cb-08dcd88f73d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-10a1-74e0-80cb-08dcd88f73d0",
        "storage_key": "property/6767906449167625/01a0b672-10a1-74e0-80cb-08dcd88f73d0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/ks-merriam/cinemark-merriam-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&y_source=1_MTc0OTMxNDYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4192557242932229378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-merriam-and-xd",
      "poi_latitude": "39.0290037",
      "poi_longitude": "-94.6879504",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-789-7038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0100a-1b90-73b6-ade0-d43635ddf7c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0100a-1b90-73b6-ade0-d43635ddf7c4",
        "storage_key": "property/6767906449167625/01a0100a-1b90-73b6-ade0-d43635ddf7c4.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJoyKG-Kd-oYcRAnV3bZn0Ljo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_ee21f354-8a07-49fa-b08e-67bc7509b061",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "AMC Town Center 20",
      "poi_type": "Entertainment",
      "poi_address": "11701 Nall Ave, Leawood, KS 66211, USA",
      "poi_short_description": "Modern cinema equipped with comfy seats, luxury recliners, and a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-1118-733b-8469-d7410031d4ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-1118-733b-8469-d7410031d4ea",
        "storage_key": "property/6767906449167625/01a0b672-1118-733b-8469-d7410031d4ea.webp",
        "width": 1280,
        "height": 783
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-town-center-20?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2804340900304979407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-town-center-20",
      "poi_latitude": "38.915838",
      "poi_longitude": "-94.648325",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-498-8696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0100a-1b90-73b6-ade0-d43635ddf7c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0100a-1b90-73b6-ade0-d43635ddf7c4",
        "storage_key": "property/6767906449167625/01a0100a-1b90-73b6-ade0-d43635ddf7c4.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xgReh_qwIcRzwXH1zAF6yY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a74ebf5b-dcd3-44c4-9df5-4fe62829ce4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Topgolf Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10611 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-a10e-756b-bda7-26844e03f34c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-a10e-756b-bda7-26844e03f34c",
        "storage_key": "property/6767906449167625/019ff6a3-a10e-756b-bda7-26844e03f34c.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://topgolf.com/us/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4737452325202402593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-overland-park",
      "poi_latitude": "38.9364597",
      "poi_longitude": "-94.64818",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-562-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-30a6911275a2",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-30a6911275a2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibz1RyvqwIcRIZ0JKMrPvkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e0f9b0df-b964-44b4-8c9d-20c7f4121024",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-9489-7635-92ee-aa3260ed0269.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-9489-7635-92ee-aa3260ed0269",
        "storage_key": "property/6767906449167625/019ff6a3-9489-7635-92ee-aa3260ed0269.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-412b-77a9-bf4c-8f22e8b76645.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-412b-77a9-bf4c-8f22e8b76645",
        "storage_key": "property/6767906449167625/019ff6a4-412b-77a9-bf4c-8f22e8b76645.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_72f383bf-00e6-4e8e-9067-295fc911f898",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "AdventHealth Shawnee Mission",
      "poi_type": "Health and Wellness",
      "poi_address": "9100 W 74th St, Merriam, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0100a-083c-7753-b8e1-91ec3d9d8bed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-083c-7753-b8e1-91ec3d9d8bed",
        "storage_key": "property/6767906449167625/01a0100a-083c-7753-b8e1-91ec3d9d8bed.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-shawnee-mission",
      "poi_directions_map_url": "https://maps.google.com/?cid=13000316506480230417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-shawnee-mission",
      "poi_latitude": "38.9954504",
      "poi_longitude": "-94.6921104",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-676-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-4b03-750f-9819-be34a86731ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-4b03-750f-9819-be34a86731ed",
        "storage_key": "property/6767906449167625/019ff6a4-4b03-750f-9819-be34a86731ed.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDc_MeIvswIcREcBm6PtmarQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1e4f311f-48ba-43f9-94c2-a3236a9c8cac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "14809 W 95th St, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-14e8-768b-a06b-5bb5fae9a8e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-14e8-768b-a06b-5bb5fae9a8e9",
        "storage_key": "property/6767906449167625/01a0b672-14e8-768b-a06b-5bb5fae9a8e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=15878390663283642374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "38.9550852",
      "poi_longitude": "-94.7585547",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-894-6664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWcV1O-eVwIcRBpDmUS5gW9w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_fec2d9d1-f816-430d-9c51-e3c47126abf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Lenexa",
      "poi_type": "Health and Wellness",
      "poi_address": "15421 W 87th St Pkwy, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc995-040b-728d-8a02-b8a877135a7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-040b-728d-8a02-b8a877135a7a",
        "storage_key": "property/6767906449167625/019fc995-040b-728d-8a02-b8a877135a7a.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.carenow.com/locations/kansas-city/lenexa?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1686808750833078671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---lenexa",
      "poi_latitude": "38.9706195",
      "poi_longitude": "-94.76521780000002",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-320-4060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47eN6vKVwIcRjxFtLZ-_aBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_b88b1943-c10d-4d68-b5f9-c5b67d066440",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Lenexa Rec Center",
      "poi_type": "Health and Wellness",
      "poi_address": "17201 W 87th St Pkwy, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc995-0e45-77da-9880-937cc9c9ae41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-0e45-77da-9880-937cc9c9ae41",
        "storage_key": "property/6767906449167625/019fc995-0e45-77da-9880-937cc9c9ae41.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Rec-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11172866499214267837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lenexa-rec-center",
      "poi_latitude": "38.9697275",
      "poi_longitude": "-94.7854454",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-477-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJga7m1XWUwIcRvVWHeOL-DZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_6372c9f6-fbfe-439f-b1be-00a8b2eec861",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "16851 W 90th St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc990-c7a5-74cd-aff0-22cb511832ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc990-c7a5-74cd-aff0-22cb511832ba",
        "storage_key": "property/6767906449167625/019fc990-c7a5-74cd-aff0-22cb511832ba.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ks/lenexa?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=2747436863078274604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.9641885",
      "poi_longitude": "-94.7812141",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-888-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSVr6fHCUwIcRLBaYOkXbICY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_568b0f85-2dec-4347-8a97-6b0c3c730d7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "16970 City Center Dr, Lenexa, KS 66219, USA",
      "poi_short_description": "Low-impact studio for full-body workouts inspired by yoga, Pilates and ballet.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0100a-0a20-7530-8a01-becca22e1e02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-0a20-7530-8a01-becca22e1e02",
        "storage_key": "property/6767906449167625/01a0100a-0a20-7530-8a01-becca22e1e02.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/city-center-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=6031670569113204403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "38.9688747",
      "poi_longitude": "-94.7827264",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-717-5699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0yyCtw2VwIcRs7Yr6mzMtFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_e42b8040-6349-44ee-aeb4-911a500229d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Breathe Yoga KC",
      "poi_type": "Health and Wellness",
      "poi_address": "22909 W 83rd St, Lenexa, KS 66227, USA",
      "poi_short_description": "Yoga studio featuring classes for all experience levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-142f-71b0-9e09-8e1240d9b7ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-142f-71b0-9e09-8e1240d9b7ea",
        "storage_key": "property/6767906449167625/01a0b672-142f-71b0-9e09-8e1240d9b7ea.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://breatheyogakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13036538762712896754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "breathe-yoga-kc",
      "poi_latitude": "38.9772186",
      "poi_longitude": "-94.8519058",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-390-3134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-2cd1767dcade",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ29cyFyiRwIcR8tQcJO8W67Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_c34575b7-c4d4-4f58-9782-b5bf28b625a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Electric Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Loiret Blvd & West 95th Street, Electric Park, Lenexa, KS 66219, USA",
      "poi_short_description": "Park featuring a playground, sand volleyball courts, grassy space & a picnic shelter with grills.",
      "poi_long_description": "Park featuring a playground, sand volleyball courts, grassy space & a picnic shelter with grills.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-c504-7619-9bbf-f3b667a3ce74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-c504-7619-9bbf-f3b667a3ce74",
        "storage_key": "property/6767906449167625/019ff6a3-c504-7619-9bbf-f3b667a3ce74.webp",
        "width": 889,
        "height": 500
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Electric-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12601988370145179708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "electric-park",
      "poi_latitude": "38.9589664",
      "poi_longitude": "-94.7694085",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40e3-74c9-a099-efab022b1f4a",
        "storage_key": "property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSI5eWKUwIcRPHgbiqdB464",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4bb75d26-a101-48ee-a6e8-b700473c7944",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Black Hoof Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9053 Monticello Rd, Lenexa, KS 66220, USA",
      "poi_short_description": "A 160-acre park featuring diverse wildlife, trails, picnic shelter, playground & lake activities.",
      "poi_long_description": "A 160-acre park featuring diverse wildlife, trails, picnic shelter, playground & lake activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc991-c7f2-72a8-b2cc-0d866d644ccf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-c7f2-72a8-b2cc-0d866d644ccf",
        "storage_key": "property/6767906449167625/019fc991-c7f2-72a8-b2cc-0d866d644ccf.webp",
        "width": 889,
        "height": 500
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Black-Hoof-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4061609937874123912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-hoof-park",
      "poi_latitude": "38.9651518",
      "poi_longitude": "-94.8440674",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40e3-74c9-a099-efab022b1f4a",
        "storage_key": "property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD5faIc6WwIcRiPwuG7i8XTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2d0e05a3-5d95-4b26-a213-a18987bdf79a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Mill Creek Streamway Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10298 Ridgeview Rd, Lenexa, KS 66220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-1545-70de-92ca-ef17328ff934.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-1545-70de-92ca-ef17328ff934",
        "storage_key": "property/6767906449167625/01a0b672-1545-70de-92ca-ef17328ff934.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13696883745268866388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-creek-streamway-park",
      "poi_latitude": "38.9532829",
      "poi_longitude": "-94.7977326",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40e3-74c9-a099-efab022b1f4a",
        "storage_key": "property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZy5tzMOVwIcRVJ2SdjIbFb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_dd13648c-5303-4541-8955-b51a950a0498",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Buffalo Meadows Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9650 Lone Elm Rd, Lenexa, KS 66220, USA",
      "poi_short_description": "Dog-friendly park on 20 acres with a picnic shelter & playgrounds, plus athletic fields & a trail.",
      "poi_long_description": "Dog-friendly park on 20 acres with a picnic shelter & playgrounds, plus athletic fields & a trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-166e-74ab-8723-3de487bd0b62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-166e-74ab-8723-3de487bd0b62",
        "storage_key": "property/6767906449167625/01a0b672-166e-74ab-8723-3de487bd0b62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Buffalo-Meadows-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2495183704965201071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buffalo-meadows-park",
      "poi_latitude": "38.9535082",
      "poi_longitude": "-94.8371574",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40e3-74c9-a099-efab022b1f4a",
        "storage_key": "property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5yaz0cOWwIcRrzzLD1ysoCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_56230127-0ccd-4799-b926-88af54420e06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Little Mill Creek North Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W 79th St & Cottonwood St, Lenexa, KS 66216, USA",
      "poi_short_description": "Clean park featuring a playground for kids, a zip line, picnic tables and soccer fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc995-2f17-741f-a105-b56af459680e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-2f17-741f-a105-b56af459680e",
        "storage_key": "property/6767906449167625/019fc995-2f17-741f-a105-b56af459680e.webp",
        "width": 889,
        "height": 500
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Little-Mill-Creek-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6556700699656722618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-mill-creek-north-park",
      "poi_latitude": "38.9867621",
      "poi_longitude": "-94.7485067",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40e3-74c9-a099-efab022b1f4a",
        "storage_key": "property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6RxLJmiTwIcRuhiYJYwU_lo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c48386f6-9272-42aa-89fa-de82f7ceae84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Matt Taylor Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Rosehill Rd & W 82nd Terrace, Lenexa, KS 66215, USA",
      "poi_short_description": "Quiet park featuring tennis courts, playgrounds and swings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-1550-7362-a33a-d471c6cc0265.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-1550-7362-a33a-d471c6cc0265",
        "storage_key": "property/6767906449167625/01a0b672-1550-7362-a33a-d471c6cc0265.webp",
        "width": 889,
        "height": 500
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Matt-Taylor-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=551971977533479020&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matt-taylor-park",
      "poi_latitude": "38.9801698",
      "poi_longitude": "-94.7317917",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40e3-74c9-a099-efab022b1f4a",
        "storage_key": "property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhzhzD1STwIcRbFjazpb_qAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_124ce703-cca6-4782-b1db-943a083d8e9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Bois D’Arc Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W 88th Terrace, Lenexa, KS 66219, USA",
      "poi_short_description": "Park with pickleball courts, a playground, slides, and a picnic area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-d2a6-7255-99ab-f77c4006ddaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-d2a6-7255-99ab-f77c4006ddaf",
        "storage_key": "property/6767906449167625/019ff6a3-d2a6-7255-99ab-f77c4006ddaf.webp",
        "width": 889,
        "height": 500
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Bois-DArc-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14790587627255064876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bois-darc-park",
      "poi_latitude": "38.9691263",
      "poi_longitude": "-94.7618779",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40e3-74c9-a099-efab022b1f4a",
        "storage_key": "property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJd18eh4OUwIcRLGnTRRW5Qs0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7259b647-be83-4ddf-9000-0cffeea7596d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Freedom Fields",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "22651 W 83rd St, Lenexa, KS 66227, USA",
      "poi_short_description": "Set of well-kept baseball fields (including little league and tball) set aside for practice and games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-1956-74e4-8440-9e7e778fc547.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-1956-74e4-8440-9e7e778fc547",
        "storage_key": "property/6767906449167625/01a0b672-1956-74e4-8440-9e7e778fc547.webp",
        "width": 889,
        "height": 500
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Freedom-Fields",
      "poi_directions_map_url": "https://maps.google.com/?cid=14665930177297402126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freedom-fields",
      "poi_latitude": "38.976144",
      "poi_longitude": "-94.846864",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi1MjqS6RwIcRDkl-9srZh8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_28d4345c-8b37-4fce-909a-01e41b0190d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Ad Astra Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8265 Maurer Rd, Lenexa, KS 66219, USA",
      "poi_short_description": "Park featuring a playground, picnic areas, and an adjacent seasonal pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc995-4998-71f6-b1f3-4c9f29a98aaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-4998-71f6-b1f3-4c9f29a98aaa",
        "storage_key": "property/6767906449167625/019fc995-4998-71f6-b1f3-4c9f29a98aaa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Ad-Astra-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18310946432812181254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ad-astra-park",
      "poi_latitude": "38.97922399999999",
      "poi_longitude": "-94.769161",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-40e3-74c9-a099-efab022b1f4a",
        "storage_key": "property/6767906449167625/019ff6a4-40e3-74c9-a099-efab022b1f4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ7OftHiTwIcRBuf53MOMHf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1d3afba0-179f-4f38-929b-953bb4e03ebb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-4c36-7218-bbcb-325243983714.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-4c36-7218-bbcb-325243983714",
        "storage_key": "property/6767906449167625/019ff6a4-4c36-7218-bbcb-325243983714.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_5afd01d6-4ae1-414f-ac14-366efb5779da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "City of Lenexa - City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17101 W 87th St Pkwy, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc995-6df4-73a6-8242-dcc6fe31cb0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-6df4-73a6-8242-dcc6fe31cb0f",
        "storage_key": "property/6767906449167625/019fc995-6df4-73a6-8242-dcc6fe31cb0f.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.lenexa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5094475210756960245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-lenexa---city-hall",
      "poi_latitude": "38.9698667",
      "poi_longitude": "-94.7843444",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-477-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-4bbf-745e-96dd-9e31c5059419.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-4bbf-745e-96dd-9e31c5059419",
        "storage_key": "property/6767906449167625/019ff6a4-4bbf-745e-96dd-9e31c5059419.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo15EEKuUwIcR9a8zZjY2s0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_1a381135-d223-4234-bd7e-a4a25f03f4f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-4c36-7218-bbcb-325243983714.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-4c36-7218-bbcb-325243983714",
        "storage_key": "property/6767906449167625/019ff6a4-4c36-7218-bbcb-325243983714.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_e638ecbc-d633-47d9-98f0-d7cabfa6d842",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Midwest Trust Center",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_long_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc995-3f86-779c-8d9d-655f13b58b12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-3f86-779c-8d9d-655f13b58b12",
        "storage_key": "property/6767906449167625/019fc995-3f86-779c-8d9d-655f13b58b12.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jccc.edu/midwest-trust-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=333406106616415315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midwest-trust-center",
      "poi_latitude": "38.9252624",
      "poi_longitude": "-94.7279145",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-469-4445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRU0TRZhZ_oAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_10b1ac2c-6426-4c36-9056-39c9aebf97ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc995-4f04-7258-bac3-9b20148c648a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-4f04-7258-bac3-9b20148c648a",
        "storage_key": "property/6767906449167625/019fc995-4f04-7258-bac3-9b20148c648a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "37.5",
      "poi_walking_minutes": "13 hours 56 mins",
      "poi_biking_minutes": "3 hours 59 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-4c30-7465-a1d0-1fad605ca737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-4c30-7465-a1d0-1fad605ca737",
        "storage_key": "property/6767906449167625/019ff6a4-4c30-7465-a1d0-1fad605ca737.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_9ea2bb66-0b07-4261-a73f-2ff6ec365afa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc995-8c5f-7420-ac05-723f61adc37f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-8c5f-7420-ac05-723f61adc37f",
        "storage_key": "property/6767906449167625/019fc995-8c5f-7420-ac05-723f61adc37f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "15.6",
      "poi_walking_minutes": "5 hours 44 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-2a44-7471-9db4-0b76c31ec312.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b672-2a44-7471-9db4-0b76c31ec312",
        "storage_key": "property/6767906449167625/01a0b672-2a44-7471-9db4-0b76c31ec312.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_54497806-07d1-4508-9ed7-f82a3fbb501a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Grundfos",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9300 Loiret Blvd, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0100a-1112-74de-be86-7a8b93cbcad5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-1112-74de-be86-7a8b93cbcad5",
        "storage_key": "property/6767906449167625/01a0100a-1112-74de-be86-7a8b93cbcad5.webp",
        "width": 680,
        "height": 510
      },
      "poi_business_url": "https://www.grundfos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8014934474911703211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grundfos",
      "poi_latitude": "38.959381",
      "poi_longitude": "-94.7716232",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 844-403-1543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8nfmQ2VwIcRq-Ako3DEOm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_aa08371e-ad7a-4c5c-981d-d010ba85ab5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Quest Diagnostics",
      "poi_type": "Health and Wellness",
      "poi_address": "Psc, 10101 Renner Blvd 1st Floor, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-1e63-738d-a1f8-fbc6c660f946.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-1e63-738d-a1f8-fbc6c660f946",
        "storage_key": "property/6767906449167625/01a0b672-1e63-738d-a1f8-fbc6c660f946.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.questdiagnostics.com/ks/lenexa/10101-renner-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=8308711658607195254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quest-diagnostics",
      "poi_latitude": "38.946177",
      "poi_longitude": "-94.776076",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-577-1770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdOOCVuUwIcRdrRtaDt5TnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_lab"
    },
    {
      "id": "custom_3ae2c722-675e-442d-9059-d1090704a204",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "JCPenney Distribution Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "10500 Lackman Rd, Lenexa, KS 66219, USA",
      "poi_short_description": "Chain department store selling a wide selection of brand-name clothing, footwear, furniture & more.",
      "poi_long_description": "Chain department store selling a wide selection of brand-name clothing, footwear, furniture & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0100a-138f-7247-af0b-370783e6f660.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-138f-7247-af0b-370783e6f660",
        "storage_key": "property/6767906449167625/01a0100a-138f-7247-af0b-370783e6f660.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.jcpenney.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2733105575562216438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jcpenney-distribution-center",
      "poi_latitude": "38.9377289",
      "poi_longitude": "-94.76588970000002",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-492-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-TKutviUwIcR9oMGVQrx7SU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_6f11481c-0e47-44bd-9b5f-ae1141f769ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "CommunityAmerica Credit Union",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9777 Ridge Dr, Lenexa, KS 66219, USA",
      "poi_short_description": "Credit union providing personal and business banking services, as well as mortgages, and insurance.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-1e5e-7119-a570-d1bdedd05e81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-1e5e-7119-a570-d1bdedd05e81",
        "storage_key": "property/6767906449167625/01a0b672-1e5e-7119-a570-d1bdedd05e81.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.communityamerica.com/?utm_source=GoogleMyBusiness&utm_medium=organic&utm_campaign=Corporate",
      "poi_directions_map_url": "https://maps.google.com/?cid=13806785953185911937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "communityamerica-credit-union",
      "poi_latitude": "38.9507296",
      "poi_longitude": "-94.7762",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-905-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk_UMD12UwIcRgdR_RayOm78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_b9a13ee9-86b2-4a04-9749-cae1ca9b7273",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Flowers Baking Co. of Lenexa",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8960 Marshall Dr, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0100a-1632-72af-bab8-b56a6086f6f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-1632-72af-bab8-b56a6086f6f1",
        "storage_key": "property/6767906449167625/01a0100a-1632-72af-bab8-b56a6086f6f1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.flowersfoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10449454337111847607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flowers-baking-co-of-lenexa",
      "poi_latitude": "38.9654778",
      "poi_longitude": "-94.7254221",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-564-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrZMcgVLrwIcRt3I3JFvrA5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_2229020f-ee0b-472c-8bf0-db7d181fa637",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Rockwell Collins - Lenexa",
      "poi_type": "Transportation & Transit",
      "poi_address": "15701 W 95th St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b672-2049-7351-9478-eb0a44ef4009.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-2049-7351-9478-eb0a44ef4009",
        "storage_key": "property/6767906449167625/01a0b672-2049-7351-9478-eb0a44ef4009.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.collinsaerospace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13042005669828156951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockwell-collins---lenexa",
      "poi_latitude": "38.9554245",
      "poi_longitude": "-94.7686381",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-338-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0FENSeVwIcRF968pA6D_rQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_fce93052-fb2d-4fea-8999-c950764dc712",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Amazon MCI5",
      "poi_type": "Major Employers & Offices",
      "poi_address": "16851 W 113th St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-2458-7455-9c71-e7ca5783b1e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-2458-7455-9c71-e7ca5783b1e9",
        "storage_key": "property/6767906449167625/019ff6a4-2458-7455-9c71-e7ca5783b1e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17188903443457799781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-mci5",
      "poi_latitude": "38.921271",
      "poi_longitude": "-94.782689",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 855-254-8971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxK666-VwIcRZXbKcZxAi-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_b6a090c6-aed0-49bc-9df6-563e7e40a6dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Thermo Fisher Scientific",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12076 Santa Fe Trail Dr, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019fc995-5548-752d-bc57-d07403853abc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-5548-752d-bc57-d07403853abc",
        "storage_key": "property/6767906449167625/019fc995-5548-752d-bc57-d07403853abc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thermofisher.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14286867956250460371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thermo-fisher-scientific",
      "poi_latitude": "38.96879",
      "poi_longitude": "-94.7254028",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-766-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwXAVC1PrwIcR00A4DbYmRcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f850c3da-e0a0-4e58-90ef-fef2d38267dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-057c-7309-8001-225cbeb79199.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-057c-7309-8001-225cbeb79199",
        "storage_key": "property/6767906449167625/019ff6a4-057c-7309-8001-225cbeb79199.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-414c-74c1-b947-4b8197706798",
        "storage_key": "property/6767906449167625/019ff6a4-414c-74c1-b947-4b8197706798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_0665b68a-71e8-4de1-b92c-90879320015e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "poi_name": "University of Kansas Edwards Campus",
      "poi_type": "Education",
      "poi_address": "12600 S Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a3-e77a-7373-a623-f9e97eac12ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-e77a-7373-a623-f9e97eac12ca",
        "storage_key": "property/6767906449167625/019ff6a3-e77a-7373-a623-f9e97eac12ca.webp",
        "width": 1280,
        "height": 795
      },
      "poi_business_url": "http://edwardscampus.ku.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15421529977661014929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-kansas-edwards-campus",
      "poi_latitude": "38.900081",
      "poi_longitude": "-94.7254776",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-897-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-400e-762f-bd0b-2cd1767dcade",
        "storage_key": "property/6767906449167625/019ff6a4-400e-762f-bd0b-2cd1767dcade.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcfRKua3qwIcRkcOF085HBNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "ec_adf3f0606623e68e22f80fe4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7b31f0d48538b33f62b486ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_97c22ce5cb30eea3d60d11a7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_68be994ead6277c8f611ba49",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e2227fdf9afab7edb9dfd7ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_cce7419608d7e8a194026e39",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_ef3cdfe495517add8124df4b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "rating": "5",
      "name": "Melissa Mathis",
      "text": "I love living here. I've lived here going on 2 years now, and this place is so laid back, calm and respectful. Every office personnel is very respectful and nice and helpful Shawna. The manager she is just amazing, she is amazing.  She'll go out of her way to help you with a thing you need help with.",
      "date": "2026-03-30",
      "title": "false"
    },
    {
      "id": "ec_a2c5d62bd2ab99f416f084d4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "rating": "5",
      "name": "Abbey Morris",
      "text": "Wonderful management. Best we've ever had the pleasure to experience. The pet royalty card saved us about $100 on our dogs vet visit! They are always quick to answer the phone about any maintenance problems big or small. Great, friendly staff. Thank you price brother's management! Our porch view is gorgeous year round.",
      "date": "2026-04-29",
      "title": "false"
    },
    {
      "id": "ec_22c0a27a1b966c7e075995f2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "rating": "5",
      "name": "Andrea Peacock",
      "text": "It has been about 3 or 4 years since I have lived in Wind River Lodge Apt. and only now can I give a fair review.  After living in a house for 20ish years, downing sizing and moving into a complex was a bit scary.  At the present moment, I truly feel grateful I found this location.  I love my home, yes it is an apartment but it is now my home.\nThe office team is friendly and professional, they go above and beyond to make sure updates and issues are taken care of.  They also throw the BEST community get- together for the complex!  My go to person has been Mariangela and her kindness and follow through has made me feel seen and secure.  (even if it might be a silly question)\nHowever, hands down the maintenance team is 10 stars, WOW!  Overall their competence is above standards and I am so thankful for them.  They take care of business in a timely manner and if I am home they kindly explain answers to any of my questions.  Whoever hires these people has a high moral gauge.\nI feel thankful and blessed to be here at Wind River Lodge.  Usually I don’t do reviews, but I can only hope this helps people make decisions to where they would like to reside.",
      "date": "2026-03-06",
      "title": "false"
    },
    {
      "id": "ec_88d8e954e89bfcc581c0cee8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "rating": "5",
      "name": "Megan Isringhausen",
      "text": "I love my apartment, the maintenance staff is great and they respond quickly. The buildings are older and it shows a little but everything works, which is more than I can say about my last apartment. The neighbors are nice and don’t start drama, the office doesn’t bother you with complaints. The only downside is the lack of ventilation. The bathroom fans do nothing. I have to buy a dehumidifier for both bedrooms and one for the other living spaces.",
      "date": "2026-04-23",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [
    {
      "id": "custom_8e25f41f-58a1-4237-8b1f-178a728c0976",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_4056e7b2-7b38-4704-8af5-521c3ef148b6",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_28c7fe37-7617-4b24-89c2-5930206dfd52",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_752f6bc9-9bf9-456f-8ae8-d82dc11a3c09",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d6f5680b-c3af-4039-875a-0ae10b2885a5",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_96a2d6ce-4b22-4532-8218-414b6e2310d4",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_115339d4-4e9a-470c-9d3d-9e4ae17c8bc2",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_73233dcf-260f-4d11-80d1-cc8afeb3f869",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, electric and gas.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_2982a149-1b22-41d2-8d89-b1399ddc62d7",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c80b5796-f962-4d1f-ac30-18394c14262d",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_65f2c6d5-7e9a-4ddf-b5f6-145504362653",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_0ebf56de-c58e-4fe5-8f2f-d996447fbd0c",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_5a0fa77a-5b9c-4a10-aab5-00e3236252bb",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_7d9b1e7c-f123-431b-9de8-86e91b7d12be",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer carports for a monthly fee. Please <a href=\"/contact-us\">contact the office</a> for our most current carport availability and pricing.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_6141debc-c0e5-4010-8a5e-8305fa4c443f",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_e8f96cbd-2e81-4113-9b1f-da5c80d0964d",
      "question": "Can I rent the clubhouse for a private event?",
      "answer": "Yes! Please <a href=\"/contact-us\">contact the leasing office</a> for pricing and availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_433ec78c-6528-48d7-81d2-d008bd044736",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_7da24769-e27f-49fc-ba0c-ad12d189d1d8",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-532e-70af-8fe6-57e232a69daf",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Wind River Lodge Apartments & Townhomes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625"
    },
    {
      "lead_collector_id": "01a0c9ac-53a3-76a1-95bd-c9eccd533841",
      "lead_source": "LANDING_PAGE",
      "name": "Wind River Lodge Apartments & Townhomes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "apartments-with-in-unit-laundry-lenexa-ks",
      "search_query": "apartments with in-unit laundry Lenexa KS",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Lenexa, KS",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Wind River Lodge. Enjoy a modern lifestyle in Lenexa, KS with our spacious layouts and top-notch amenities.",
      "page_copy": "Experience the ultimate convenience with apartments featuring in-unit laundry at Wind River Lodge in Lenexa, KS. Located in the delightful Chesapeake Estates, our community offers more than just laundry conveniences—it provides a comfortable living with spacious apartment and townhome layouts designed to fit your lifestyle. Whether you are enjoying a match on our tennis courts or relaxing in the lounge, you'll appreciate coming home to a well-equipped residence.\n\nAt Wind River Lodge, we understand the need for modern amenities like in-unit laundry, making everyday chores hassle-free. Our community is more than just apartments; it’s a lifestyle embraced by carefully curated spaces to foster relaxation and enjoyment. Located in Johnson County, our prime location offers easy access to Lenexa's amenities while you savor the comfort of a residential retreat. Schedule a tour today to find out how our accommodations can be your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Lenexa, KS",
      "seo_description": "Find apartments with in-unit laundry in Lenexa, KS. Discover Wind River Lodge's modern living and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-johnson-county",
      "search_query": "luxury apartments with pool Johnson County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Johnson County",
      "h2_subtitle": "Unwind at Wind River Lodge's luxury pool. Experience upscale living in Johnson County with unparalleled amenities and comfort.",
      "page_copy": "Nestled in the heart of Johnson County, Wind River Lodge offers luxury apartments with a stunning pool that redefines relaxation. Imagine yourself lounging by the water, basking in the glow of the sun, and enjoying all the comforts of upscale apartment living. Our community provides more than just beautiful views; it delivers a complete lifestyle package. Featuring non-smoking areas, a recreation lounge, and even a family room, our apartments cater to every resident’s desire for comfort.\n\nLiving in our luxury apartments means you are not only getting access to high-end amenities like our pool but also enjoying the vibrant environment of Lenexa's Chesapeake Estates. The spacious layouts and contemporary designs of our apartments and townhomes invite you to experience an elevated standard of living. Situated conveniently in Johnson County, Wind River Lodge is your gateway to elegant living combined with exclusive community features.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Johnson County",
      "seo_description": "Explore luxury apartments with a pool in Johnson County. Exceptional amenities await at Wind River Lodge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "pet-friendly-townhomes-chesapeake-estates",
      "search_query": "pet-friendly townhomes Chesapeake Estates",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Townhomes in Chesapeake Estates",
      "h2_subtitle": "Welcome to Wind River Lodge's pet-friendly townhomes. Experience spacious, pet-loving homes in Chesapeake Estates, Lenexa.",
      "page_copy": "Explore pet-friendly townhomes at Wind River Lodge in Chesapeake Estates—where pets are not just welcomed, they're adored! Situated in the charming Lenexa area, our townhomes provide ample space for you and your furry friends to feel right at home. Our community offers the ideal setting with standout amenities that ensure both you and your pets enjoy the highest quality of life.\n\nWind River Lodge pairs comfortable living spaces with a dedication to pet-friendly environments in the heart of Chesapeake Estates. The community features thoughtful amenities such as designated smoking areas, communal lounges, and expansive recreational spaces, making it the perfect place for pet owners to settle. Come see how Wind River Lodge can be your pet’s new favorite spot in Lenexa by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Townhomes in Chesapeake Estates",
      "seo_description": "Find pet-friendly townhomes in Chesapeake Estates at Wind River Lodge. Enjoy spacious living in Lenexa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "modern-apartments-with-air-conditioning-lenexa",
      "search_query": "modern apartments with air conditioning Lenexa",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Air Conditioning",
      "h2_subtitle": "Find comfort at Wind River Lodge with modern air-conditioned apartments in Lenexa. Enjoy a cool retreat in Chesapeake Estates.",
      "page_copy": "Stay comfortable in the heat with modern apartments that feature air conditioning at Wind River Lodge in Lenexa. Our community, located in the scenic Chesapeake Estates, combines contemporary living with practical comforts to create a perfect home environment. Designed for modern life, our spacious apartment and townhome layouts ensure you enjoy the cool retreat offered by efficient air conditioning systems.\n\nWind River Lodge is the perfect residence for those seeking modern amenities alongside traditional conveniences. Enjoy the benefits of a smoke-free community with designated areas, a family room, and recreational lounges. The community amenities extend beyond just comfortable living, providing a unique lifestyle blend for our residents. Discover life-altering comfort and schedule a visit to see how Wind River Lodge can be your air-conditioned sanctuary in Lenexa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Air Conditioning",
      "seo_description": "Explore modern apartments with air conditioning in Lenexa at Wind River Lodge. Enjoy stylish living in Chesapeake Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "spacious-apartments-with-dishwasher-near-i-435",
      "search_query": "spacious apartments with dishwasher near I-435",
      "category": "Amenity",
      "h1_title": "Spacious Apartments with Dishwasher",
      "h2_subtitle": "Discover Wind River Lodge’s spacious apartments with dishwashers, conveniently located near I-435 in Lenexa.",
      "page_copy": "At Wind River Lodge, find spacious apartments equipped with dishwashers, making everyday living a breeze. Nestled near the convenience of I-435, our community in Lenexa offers easy access to major commuting routes while providing a serene retreat. Enjoy modern layouts that prioritize both space and utility, ensuring every apartment feels welcoming and practical, especially with our efficient dishwashers to simplify chores.\n\nSituated in the picturesque Chesapeake Estates, Wind River Lodge features not only functional living spaces but also a variety of community amenities. Residents love our lounge, tennis courts, and designated smoke-free areas. Whether you’re relaxing at home or enjoying the vibrant community around you, our apartments offer the perfect blend of convenience and comfort. Experience the benefits of living at Wind River Lodge by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments with Dishwasher",
      "seo_description": "Find spacious apartments with dishwashers near I-435 at Wind River Lodge in Lenexa. Enjoy modern living in Chesapeake Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-lenexa-ks",
      "search_query": "one bedroom apartments lenexa ks",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Lenexa, KS",
      "h2_subtitle": "Explore Wind River Lodge's one bedroom apartments in Lenexa, KS. Ideal for modern living in Chesapeake Estates.",
      "page_copy": "Discover the perfect one bedroom apartments at Wind River Lodge in Lenexa, KS. Our community offers the ideal blend of contemporary style and convenience, nestled in the peaceful Chesapeake Estates neighborhood. Each apartment is thoughtfully designed to maximize comfort and functionality, providing a relaxed living environment in lovely Lenexa.\n\nAt Wind River Lodge, you'll enjoy more than just a great home. Our community amenities, including a family room, lounge, and tennis court, provide additional spaces to relax and socialize. Designated smoke-free areas ensure a clean environment, while our location provides easy access to nearby shopping and dining options. Come experience the charm of our one bedroom apartments and see how Wind River Lodge can be the perfect fit for your lifestyle. Schedule your visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Lenexa, KS",
      "seo_description": "Find stylish one bedroom apartments at Wind River Lodge in Lenexa, KS. Experience modern living in Chesapeake Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "two-bedroom-townhomes-johnson-county",
      "search_query": "two bedroom townhomes johnson county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Townhomes in Johnson County",
      "h2_subtitle": "Discover spacious two bedroom townhomes at Wind River Lodge, located in the heart of Johnson County's Chesapeake Estates.",
      "page_copy": "Experience the comfort of living in two-bedroom townhomes at Wind River Lodge, situated in the tranquil Chesapeake Estates of Johnson County. Our townhomes offer ample space designed for modern living, featuring expansive layouts that provide both privacy and convenience. Ideal for anyone seeking extra room, our townhomes cater to a variety of lifestyles.\n\nIn addition to spacious interiors, residents enjoy access to premium community amenities such as a relaxing lounge, a family room, tennis courts, and designated smoke-free areas. The benefit of living at Wind River Lodge extends beyond the doorstep with easy access to the vibrant surroundings of Johnson County. Whether you're looking to enjoy the natural beauty or the convenience of nearby shopping and dining, our community is the perfect place to call home. Schedule a tour today and see firsthand what makes our townhomes a standout choice!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Townhomes in Johnson County",
      "seo_description": "Explore two bedroom townhomes at Wind River Lodge in Johnson County. Spacious living in Lenexa's Chesapeake Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "apartments-near-sunflower-elementary-school-lenexa",
      "search_query": "apartments near Sunflower Elementary School Lenexa",
      "category": "School",
      "h1_title": "Apartments Near Sunflower Elementary School",
      "h2_subtitle": "Find apartments at Wind River Lodge, conveniently located near Sunflower Elementary School in Lenexa.",
      "page_copy": "Wind River Lodge offers apartments just a short distance from Sunflower Elementary School in Lenexa. Our community provides spacious layouts and modern conveniences in a peaceful neighborhood setting. \n\nLocated in the welcoming Chesapeake Estates neighborhood, Wind River Lodge combines comfort with community amenities like a family room, lounge, and tennis courts. The non-smoking community ensures a clean and healthy living environment. With quick access to major commuting routes and local attractions, residents enjoy the balance of suburban tranquility and urban conveniences. Discover how Wind River Lodge can be your next home by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sunflower Elementary School",
      "seo_description": "Live near Sunflower Elementary in Lenexa at Wind River Lodge apartments. Ideal location in Chesapeake Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "lenexa-hills-elementary-school-nearby-apartments",
      "search_query": "Lenexa Hills Elementary School nearby apartments",
      "category": "School",
      "h1_title": "Apartments Near Lenexa Hills Elementary",
      "h2_subtitle": "Discover convenient living options near Lenexa Hills Elementary School. Explore apartments at Wind River Lodge.",
      "page_copy": "At Wind River Lodge, you'll find the perfect apartments conveniently located near Lenexa Hills Elementary School. Our community offers both spacious apartments and townhome-style layouts, designed with modern living in mind. With quick access to quality education, our location in Chesapeake Estates is perfect for those seeking a balanced lifestyle in Lenexa.\n\nResidents of Wind River Lodge enjoy more than just proximity to great schools. Our community boasts amenities such as a family room, lounge, and tennis courts, providing spaces to unwind and socialize. With designated smoking areas, we maintain a smoke-free environment for healthier living. Located in the serene backdrop of Chesapeake Estates, residents also benefit from easy access to local amenities and attractions. Schedule a visit today and see how our community can be the right fit for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lenexa Hills Elementary School",
      "seo_description": "Explore Wind River Lodge for apartments near Lenexa Hills Elementary. Convenient location in Chesapeake Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "wind-river-lodge-near-rosehill-elementary-school",
      "search_query": "Wind River Lodge near Rosehill Elementary School",
      "category": "School",
      "h1_title": "Wind River Lodge by Rosehill Elementary",
      "h2_subtitle": "Explore spacious living near Rosehill Elementary School at Wind River Lodge, a welcoming community in Lenexa.",
      "page_copy": "Wind River Lodge provides a welcoming community located conveniently near Rosehill Elementary School. Nestled in the serene Chesapeake Estates neighborhood, our apartments and townhomes offer spacious living areas and modern amenities in a vibrant community.\n\nResidents at Wind River Lodge benefit not only from a prime location but also from abundant amenities like a family room, tennis court, and a comfortable lounge area, all within a non-smoking environment. Situated in Lenexa, our community allows easy access to shopping, dining, and entertainment options, making it a convenient base for your daily activities. Whether you're looking to move closer to Rosehill Elementary or explore comfortable living spaces in Lenexa, Wind River Lodge offers the perfect solution. Schedule a tour today to see why this community is the right choice for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wind River Lodge by Rosehill Elementary School",
      "seo_description": "Discover comfortable living at Wind River Lodge, near Rosehill Elementary in Lenexa. Ideal location in Chesapeake Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "apartments-close-to-westridge-middle-school-lenexa-ks",
      "search_query": "apartments close to Westridge Middle School Lenexa KS",
      "category": "School",
      "h1_title": "Apartments Close to Westridge Middle School",
      "h2_subtitle": "Wind River Lodge offers apartments near Westridge Middle School in Lenexa, KS, ensuring quality living and convenience.",
      "page_copy": "Experience comfortable living at Wind River Lodge, conveniently located near Westridge Middle School in Lenexa, KS. Our community boasts spacious apartments and townhomes with easy access to Westridge Middle School. \n\nWind River Lodge, nestled in the peaceful Chesapeake Estates, offers more than just a convenient location. Enjoy our on-site amenities, including a family room, dedicated lounge, and tennis courts, all within a smoke-free living environment. Our proximity to shopping and dining enhances the suburban lifestyle you're looking for. Discover an ideal blend of comfort, convenience, and community by exploring Wind River Lodge today. Schedule a tour to find out how our community fits your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Westridge Middle School Lenexa KS",
      "seo_description": "Find spacious apartments near Westridge Middle School at Wind River Lodge in Lenexa, KS. Explore Chesapeake Estates living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "shawnee-mission-west-high-school-nearby-apartments",
      "search_query": "Shawnee Mission West High School nearby apartments",
      "category": "School",
      "h1_title": "Apartments Near Shawnee Mission West High School",
      "h2_subtitle": "Discover convenient living at Wind River Lodge, close to Shawnee Mission West High School in Lenexa, KS.",
      "page_copy": "Wind River Lodge offers spacious apartments and townhomes near Shawnee Mission West High School in Lenexa, KS. Enjoy modern conveniences and a welcoming community within reach of everything you need. \n\nWithin the tranquil Chesapeake Estates, Wind River Lodge highlights key amenities such as a family room, lounge, and tennis courts. Our smoke-free community, along with designated areas for smoking, ensures a clean and healthy lifestyle. With easy access to local shopping, dining, and recreational options, our location is unmatched for convenience. Visit us today to see how Wind River Lodge offers comfort and accessibility near Shawnee Mission West High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Shawnee Mission West High School",
      "seo_description": "Find apartments at Wind River Lodge near Shawnee Mission West High School in Lenexa, KS. Enjoy Chesapeake Estates living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "apartments-near-johnson-county-community-college",
      "search_query": "apartments near Johnson County Community College",
      "category": "School",
      "h1_title": "Apartments Near Johnson County Community College",
      "h2_subtitle": "Discover student-friendly living at Wind River Lodge, conveniently positioned near Johnson County Community College in Lenexa, KS.",
      "page_copy": "Wind River Lodge provides an excellent option for students and professionals seeking apartments near Johnson County Community College. Located in Lenexa, KS, this community combines the convenience of proximity with the comforts of home. Enjoy spacious apartment and townhome layouts that cater to all your needs while pursuing academic or professional goals.\n\nSituated in the serene Chesapeake Estates, Wind River Lodge offers standout amenities including a lounge, tennis court, and a designated smoke-free environment that promotes a healthy lifestyle. Our close vicinity to Johnson County Community College makes it easy to attend classes and participate in college activities, while still enjoying access to local dining and entertainment. Schedule a tour today to experience firsthand how our community can enhance your lifestyle and educational journey.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Johnson County Community College",
      "seo_description": "Find student-friendly living at Wind River Lodge, near JCCC in Lenexa, KS. Experience convenience and comfort in Chesapeake Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "apartments-close-to-park-university-lenexa-ks",
      "search_query": "apartments close to Park University Lenexa KS",
      "category": "School",
      "h1_title": "Apartments Close to Park University Lenexa",
      "h2_subtitle": "Enjoy convenient student living at Wind River Lodge, close to Park University in Lenexa, KS, offering comfort and accessibility.",
      "page_copy": "Located near Park University in Lenexa, KS, Wind River Lodge provides the perfect living solution for students and academics. Our community features spacious apartments and townhomes designed for comfort and convenience, making it easy to balance study and relaxation.\n\nNestled in Chesapeake Estates, Wind River Lodge boasts a range of amenities including a communal lounge, a family room, and a tennis court, all within a clean, smoke-free environment with designated smoking areas. With quick access to Park University, attending classes and campus events has never been easier. Our community also puts you close to local dining, shopping, and recreational opportunities, enabling a balanced lifestyle. Discover the benefits of living at Wind River Lodge by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Park University Lenexa KS",
      "seo_description": "Explore student accommodations at Wind River Lodge, close to Park University in Lenexa, KS. Experience comfortable living in Chesapeake Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "university-of-kansas-edwards-campus-apartments-lenexa",
      "search_query": "University of Kansas Edwards Campus apartments in Lenexa",
      "category": "School",
      "h1_title": "Lenexa Apartments Near KU Edwards Campus",
      "h2_subtitle": "Wind River Lodge offers spacious living just minutes from the University of Kansas Edwards Campus in Lenexa, KS.",
      "page_copy": "Wind River Lodge in Lenexa, KS, offers a modern and convenient home base for students, faculty, and staff of the University of Kansas Edwards Campus. Our selection of spacious apartment and townhome layouts provides the ideal setting for balanced living, combining study and leisure effortlessly.\n\nSituated within Chesapeake Estates, our community boasts amenities such as a lounge, family room, and tennis courts, alongside designated smoking areas in a clean, smoke-free environment. Proximity to the KU Edwards Campus ensures stress-free commutes, while nearby shopping, dining, and entertainment options add even more convenience. Discover how Wind River Lodge supports your academic journey with comfort and accessibility by scheduling a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lenexa Apartments Near KU Edwards Campus",
      "seo_description": "Find your home at Wind River Lodge, minutes from KU Edwards Campus in Lenexa. Enjoy comfort and convenience in Chesapeake Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "apartments-near-adventhealth-shawnee-mission-lenexa",
      "search_query": "apartments near AdventHealth Shawnee Mission Lenexa KS",
      "category": "Hospital",
      "h1_title": "Affordable Apartments Near AdventHealth Shawnee",
      "h2_subtitle": "Wind River Lodge offers comfortable living options near AdventHealth Shawnee Mission in Lenexa, KS, ideal for healthcare professionals.",
      "page_copy": "Wind River Lodge presents the perfect living option for healthcare professionals needing proximity to AdventHealth Shawnee Mission in Lenexa, KS. Our community offers spacious and thoughtfully designed apartment and townhome-style living, ensuring you enjoy both work and relaxation in harmony.\n\nLocated in the heart of Chesapeake Estates, residents benefit from a range of amenities including a relaxing lounge, a smoke-free environment with designated smoking areas, a family room, and tennis courts. The quick commute to AdventHealth Shawnee Mission means professionals can focus on their careers without the stress of a lengthy drive. Plus, with access to local dining and entertainment, you’ll find it easy to unwind and enjoy your free time. Experience how Wind River Lodge can enhance your lifestyle by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lenexa Apartments Near AdventHealth Shawnee",
      "seo_description": "Discover comfort at Wind River Lodge, close to AdventHealth Shawnee Mission, Lenexa. Experience convenience and community in Chesapeake Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "apartments-near-sar-ko-par-trails-park-lenexa",
      "search_query": "apartments near Sar-Ko-Par Trails Park Lenexa",
      "category": "Park",
      "h1_title": "Apartments Close to Sar-Ko-Par Trails Park",
      "h2_subtitle": "Wind River Lodge offers ideal living with close access to Sar-Ko-Par Trails Park, perfect for enjoying outdoor activities in Lenexa, KS.",
      "page_copy": "Discover the ideal blend of comfort and nature at Wind River Lodge Apartments & Townhomes in Lenexa, KS, located near the beautiful Sar-Ko-Par Trails Park. Our community provides spacious living options and an array of amenities that cater to those who appreciate outdoor activities and peaceful surroundings.\n\nResiding in Chesapeake Estates, our non-smoking community features amenities like a family room, lounge, and tennis courts, offering both relaxation and recreation for residents. Just a short distance from Sar-Ko-Par Trails Park, you'll have immediate access to jogging paths, picnic areas, and serene lakes, making it an outdoor enthusiast’s dream location. Embrace the convenience and tranquility of living at Wind River Lodge and schedule a visit today to see this exceptional community firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lenexa Apartments Near Sar-Ko-Par Trails Park",
      "seo_description": "Live close to nature at Wind River Lodge, near Sar-Ko-Par Trails Park in Lenexa, offering comfort and convenient access to outdoor recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "new-townhomes-close-to-electric-park-ks",
      "search_query": "new townhomes close to Electric Park KS",
      "category": "Park",
      "h1_title": "New Townhomes Near Electric Park, KS",
      "h2_subtitle": "Explore modern townhomes at Wind River Lodge, conveniently located near Electric Park in Lenexa, KS, offering both style and convenience.",
      "page_copy": "Wind River Lodge Apartments & Townhomes presents a stylish selection of new townhomes located conveniently close to Electric Park in Lenexa, KS. Offering spacious layouts paired with modern designs, these homes are perfect for those seeking both comfort and proximity to local attractions.\n\nNestled in the picturesque Chesapeake Estates, our community elevates your living experience with amenities such as a lounge, family room, and tennis court, while maintaining a smoke-free environment with designated areas. Being near Electric Park means residents can easily enjoy community events and leisure activities. Whether you're looking to unwind or engage in local events, Wind River Lodge provides the ideal setting. Schedule a tour today to explore our thriving community and see how it can complement your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Near Electric Park, Lenexa KS",
      "seo_description": "Discover new townhomes at Wind River Lodge, close to Electric Park, Lenexa, offering modern comfort and community amenities in Chesapeake Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "lenexa-rentals-by-black-hoof-park",
      "search_query": "Lenexa rentals by Black Hoof Park",
      "category": "Park",
      "h1_title": "Spacious Lenexa Rentals Near Black Hoof Park",
      "h2_subtitle": "Enjoy the serenity of Black Hoof Park with our Lenexa rentals, offering a blend of modern living and natural beauty at Wind River Lodge.",
      "page_copy": "Wind River Lodge Apartments & Townhomes offers an exceptional rental experience in Lenexa, KS, just minutes from the natural beauty of Black Hoof Park. Our community provides spacious and contemporary living spaces ideal for those who love to balance modern comfort with outdoor adventures.\n\nLocated in the charming Chesapeake Estates, residents benefit from a non-smoking community featuring a lounge, family room, and tennis courts. This prime location near Black Hoof Park allows you to enjoy peaceful walking trails, bird watching, and picnics in well-maintained green spaces. Whether you're a nature enthusiast or just seeking a relaxing environment, Wind River Lodge is the perfect choice. Schedule a tour today and explore how our community meets your desires for both convenience and serenity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lenexa Rentals Near Black Hoof Park",
      "seo_description": "Explore rentals at Wind River Lodge by Black Hoof Park, Lenexa. Offering spacious living and modern amenities in a serene setting near the park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "chesapeake-estates-apartments-near-mill-creek-streamway",
      "search_query": "Chesapeake Estates apartments close to Mill Creek Streamway Park",
      "category": "Park",
      "h1_title": "Chesapeake Estates Apts by Mill Creek Streamway",
      "h2_subtitle": "Discover elegant Chesapeake Estates apartments near Mill Creek Streamway Park, offering a unique blend of comfort and nature in Lenexa, KS.",
      "page_copy": "Located in Lenexa, KS, Wind River Lodge Apartments & Townhomes offers a charming lifestyle in the sought-after Chesapeake Estates, conveniently close to Mill Creek Streamway Park. Our community is perfect for those who enjoy spacious living quarters paired with convenient access to outdoor adventures.\n\nEnjoy the non-smoking environment at Wind River Lodge, which features a tennis court, relaxing lounge, and family room. The nearby Mill Creek Streamway Park provides endless opportunities for hiking, biking, and enjoying the serene waterways. Embrace the opportunity to live in a community that offers both bustling amenities and tranquil green spaces. Tour today and see how Wind River Lodge can be the perfect place for you to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chesapeake Estates Apts Near Mill Creek Park",
      "seo_description": "Explore Chesapeake Estates apartments at Wind River Lodge, near Mill Creek Streamway Park in Lenexa, KS. Enjoy modern living with nature trails nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "johnson-county-rentals-buffalo-meadows-park",
      "search_query": "Johnson County rentals near Buffalo Meadows Park",
      "category": "Park",
      "h1_title": "Johnson County Rentals by Buffalo Meadows Park",
      "h2_subtitle": "Explore the ideal blend of comfort and convenience with our Johnson County rentals near Buffalo Meadows Park at Wind River Lodge.",
      "page_copy": "Nestled in the vibrant community of Lenexa, KS, Wind River Lodge Apartments & Townhomes offers exceptional Johnson County rentals near the picturesque Buffalo Meadows Park. Our spacious apartments and townhomes provide the perfect backdrop for comfortable living, while the park offers a natural retreat within walking distance.\n\nWind River Lodge features a non-smoking community environment with a welcoming lounge, family room, and tennis court, ensuring a wide range of leisure activities. The proximity to Buffalo Meadows Park invites residents to enjoy lush open spaces and serene walking trails. Experience the perfect balance of relaxation and activity by choosing Wind River Lodge as your next address. Visit us today to see how our community complements both modern living and a love for nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Johnson County Rentals Near Buffalo Meadows Park",
      "seo_description": "Find rentals at Wind River Lodge in Johnson County, close to Buffalo Meadows Park. Enjoy spacious living with outdoor adventures nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "apartments-little-mill-creek-north-park-lenexa",
      "search_query": "apartments near Little Mill Creek North Park Lenexa",
      "category": "Park",
      "h1_title": "Apartments Near Little Mill Creek North Park",
      "h2_subtitle": "Discover the perfect Lenexa lifestyle with our apartments near Little Mill Creek North Park, where nature and contemporary comforts unite.",
      "page_copy": "Wind River Lodge Apartments & Townhomes is ideally situated for those seeking quality living in Lenexa, KS, just a short distance from the serene Little Mill Creek North Park. Our community offers a unique combination of spacious apartments and townhomes alongside a range of amenities designed to enhance your daily life.\n\nResidents enjoy a smoke-free environment, a cozy lounge area, a family room, and tennis courts, making leisure and relaxation easily accessible. The nearby Little Mill Creek North Park is a local gem, offering beautiful walking trails and natural landscapes. Embrace the convenience of modern-day comforts with the tranquility of nature right at your doorstep. Schedule a tour and discover why Wind River Lodge is a top choice for Lenexa living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lenexa Apartments by Little Mill Creek North Park",
      "seo_description": "Find Lenexa apartments near Little Mill Creek North Park at Wind River Lodge. Enjoy spacious living and immediate access to natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "wind-river-lodge-rentals-matt-taylor-park",
      "search_query": "Wind River Lodge rentals by Matt Taylor Park",
      "category": "Park",
      "h1_title": "Wind River Lodge Rentals by Matt Taylor Park",
      "h2_subtitle": "Experience the best of Lenexa with Wind River Lodge rentals by the scenic Matt Taylor Park, offering spacious living and community amenities.",
      "page_copy": "Situated in the heart of Lenexa, KS, Wind River Lodge Apartments & Townhomes provides an excellent option for those seeking rentals close to Matt Taylor Park. Our community blends modern, spacious living spaces with numerous amenities, ensuring comfort and convenience every day.\n\nEnjoy our non-smoking community, complete with a stylish lounge, family room, and tennis court, perfect for relaxation and recreation. The proximity to Matt Taylor Park offers an ideal space for enjoying outdoor activities or unwinding in nature's embrace. Discover the perfect harmony of lifestyle amenities and outdoor exploration at Wind River Lodge. Schedule a visit today to see why our community stands out.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Matt Taylor Park at Wind River Lodge",
      "seo_description": "Explore Wind River Lodge rentals by Matt Taylor Park in Lenexa. Enjoy modern amenities and scenic park access in our welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "chesapeake-estates-apartment-homes-bois-darc-park",
      "search_query": "Chesapeake Estates apartment homes near Bois D’Arc Park",
      "category": "Park",
      "h1_title": "Chesapeake Estates Apartments Near Bois D’Arc Park",
      "h2_subtitle": "Discover the charm of Chesapeake Estates apartment homes near Bois D’Arc Park, where modern comforts meet natural beauty in Lenexa.",
      "page_copy": "Wind River Lodge Apartments & Townhomes, located in the charming Chesapeake Estates and close to Bois D’Arc Park, offers the ideal blend of comfortable living and outdoor accessibility. Our apartment homes are designed for luxurious living, with ample spaces and convenient features just steps away from picturesque parklands.\n\nResidents enjoy amenities such as a smoke-free community, inviting lounge areas, and tennis courts, catering to diverse lifestyles and recreation needs. With Bois D’Arc Park nearby, you can enjoy leisurely outings or simply relax in nature. Wind River Lodge is where contemporary living merges seamlessly with outdoor serenity, making it a sought-after address in Lenexa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chesapeake Estates Homes Near Bois D’Arc Park",
      "seo_description": "Find Wind River Lodge apartment homes in Chesapeake Estates near Bois D’Arc Park, Lenexa, offering modern living with outdoor access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "townhomes-close-to-ad-astra-park-lenexa",
      "search_query": "townhomes close to Ad Astra Park Lenexa",
      "category": "Park",
      "h1_title": "Townhomes Close to Ad Astra Park in Lenexa",
      "h2_subtitle": "Explore our inviting townhomes close to Ad Astra Park, Lenexa, offering spacious living and excellent community features.",
      "page_copy": "Located in the vibrant city of Lenexa, Wind River Lodge Apartments & Townhomes presents an ideal choice for those seeking townhome-style living close to Ad Astra Park. Our community provides spacious and modern accommodations, perfect for anyone looking to enjoy both comfort and convenience.\n\nEnjoy a variety of amenities, such as a smoke-free environment, a well-appointed lounge, and recreational options like tennis courts. The proximity to Ad Astra Park allows residents to take advantage of green spaces, walking trails, and natural beauty, all within a short distance from home. Choose Wind River Lodge for a harmonious blend of residential luxuries and outdoor adventures.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Near Ad Astra Park in Lenexa",
      "seo_description": "Discover Wind River Lodge townhomes close to Ad Astra Park, Lenexa, where modern living meets outdoor fun in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167625",
      "source": "custom",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Find convenience and comfort at Wind River Lodge, with apartments located near Kansas City International Airport, a perfect home base in Lenexa.",
      "page_copy": "Wind River Lodge Apartments & Townhomes offer an exceptional living experience just a short drive from Kansas City International Airport. Our community in Lenexa combines modern amenities with easy access to both metropolitan conveniences and travel needs.\n\nResidents enjoy a range of features, including a smoke-free environment, cozy lounge spaces, and recreation facilities like a tennis court. Living near the airport simplifies travel plans while offering the tranquil atmosphere of Chesapeake Estates. Experience a unique blend of accessibility and suburban charm at Wind River Lodge, making your next home a hub of comfort and connectivity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and sand volleyball court with lounge chairs and a covered pavilion.",
        "public_id": "019fc990-8ab7-7389-9f31-9dd6d0ea8bdc",
        "storage_key": "property/6767906449167625/019fc990-8ab7-7389-9f31-9dd6d0ea8bdc.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Apartments Near Kansas City Airport",
      "seo_description": "Explore Wind River Lodge apartments near Kansas City International Airport, bringing you closer to travel convenience with modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12702032304"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P8CLLTMD"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 9"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/b2fdb4f7-bace-4205-9d9d-bb8bc20e5250/app.js?nocache=1&gaTracking=G-ZCF374PF2Y&buttonbgcolor=000000&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-423-3533"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im01bVRva042TWlUZGFKM0ViWTlqQXc9PSIsInZhbHVlIjoiRm0zUGt6bmIyRDI2VTR2UlByUHlaUT09IiwibWFjIjoiNjE1MjYxNTM0N2E4ZGM0MTZjOGE3Yzc5YTI4ZDkxMDFiZDEzM2RkNGYxODA0NTkzZDI2NGFlNGYzZDcyMTI0MiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12702032304",
  "custom_google_gtm_id": "GTM-P8CLLTMD",
  "custom_rollout_phase": "Batch 9",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/b2fdb4f7-bace-4205-9d9d-bb8bc20e5250/app.js?nocache=1&gaTracking=G-ZCF374PF2Y&buttonbgcolor=000000&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-423-3533",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im01bVRva042TWlUZGFKM0ViWTlqQXc9PSIsInZhbHVlIjoiRm0zUGt6bmIyRDI2VTR2UlByUHlaUT09IiwibWFjIjoiNjE1MjYxNTM0N2E4ZGM0MTZjOGE3Yzc5YTI4ZDkxMDFiZDEzM2RkNGYxODA0NTkzZDI2NGFlNGYzZDcyMTI0MiJ9",
  "custom_audioeye_site_id": "e2ef292b-f39f-4f61-95bc-289c470ddaa7",
  "custom_audioeye_site_hash": "848679e626108b8c1e48473f2bfee7ca"
};

export const generatedAt = '2026-11-03T22:58:03.245Z';
